/* eslint-disable no-shadow */
/* eslint-disable arrow-body-style */
/* eslint-disable no-await-in-loop */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';

//   utils
import { fData } from 'src/utils/format-number';
import MaskedInput from 'src/utils/MaskedInput';

//  components

import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
import { UploadBox } from 'src/components/upload';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter, useParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { _tags } from 'src/_mock';
import FormProvider, {
  RHFTextField,
  RHFAutocomplete,
  RHFRadioGroup,
  RHFUploadBox,
  RHFUploadAvatar,
} from 'src/components/hook-form';
import {
  Alert,
  Chip,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  Step,
  StepLabel,
  CircularProgress,
  Stepper,
  Switch,
  Tooltip,
} from '@mui/material';
import { decryptData, encryptData } from 'src/utils/Crypto';
import { DatePicker } from '@mui/x-date-pickers';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import axiosInstance from 'src/api/axiosInstance';
import useNavigateErrorHandler from 'src/hooks/useNavigateErrorHandler';
import { isValid, parseISO } from 'date-fns';
import { fetchEncryptedToken } from 'src/utils/encryptUtils';
import PassportNewEditForm from './passport-new-edit-form';
import FamilyRelationNewEditForm from './family-relation-new-edit-form';
import EmergencyContactNewEditForm from './emergency-contact-new-edit-form';
import EmpEduNewEditForm from './emp-edu-new-edit-form';
import EmpExpNewEditForm from './emp-repli-exp-form';
import EmpCertNewEditForm from './emp-cert-new-edit-form';
import EmpRefNewEditForm from './emp-ref-new-edit-form';
import EmpLangNewEditForm from './emp-lang-new-edit-form';
import EmpVisaNewEditForm from './emp-visa-new-edit-form';
import EmpRelwrknwithusNewEditForm from './emp-relwrknwithus-new-edit-form';
import EmpBankNewEditForm from './emp-bank-new-edit-form';
import EmpImpqueNewEditForm from './emp-impque-new-edit-form';

export default function EmployeeNewEditForm({
  currentEmpFam,
  currentEmpPass,
  currentEmpBank,
  currentEmpEdu,
  currentEmpVisa,
  currentEmpCert,
  currentEmpWrk,
  currentEmpLang,
  currentEmpEmrg,
  currentEmpRef,
  currentEmpExp,
  currentEmpImpQ,
  currentEmp,
  currentEmpView,
  disabled,
  candidateId,
  candidateData,
  id,
}) {
  const token = sessionStorage.getItem('token');
  const router = useRouter();
  const routeParams = useParams();
  const user = JSON.parse(localStorage.getItem('user')) || {};
  let subscr = null;
  console.log("in the Employee Replica File.... 1")
  try {
    const stored = localStorage.getItem('selectedSubscrSite') || '{}';
    subscr = JSON.parse(stored);
  } catch (error) {
    subscr = {};
  }

  // eslint-disable-next-line no-restricted-globals
  const isOnEmployeeForm = window.location.pathname.includes('/employeeForm');

  const loadingSend = useBoolean();
  const confirm = useBoolean();
  const { enqueueSnackbar } = useSnackbar();
  const [savedEmployeeId, setSavedEmployeeId] = useState(null);
  const [srcOfHrArr, setSrcOfHrArr] = useState([]);
  const [genderArr, setGenderArr] = useState([]);
  const [desgntnArr, setDesgntnArr] = useState([]);
  const [countryArr, setCountryArr] = useState([]);
  const [curCityArr, setCurCityArr] = useState([]);
  const [perCityArr, setPerCityArr] = useState([]);
  const [rawCityArr, setRawCityArr] = useState([]);
  const [qualArr, setQualArr] = useState([]);
  const [nmTitleArr, setNmTitleArr] = useState([]);
  const [universityArr, setUniversityArr] = useState([]);
  const [qualTypeArr, setQualTypeArr] = useState([]);
  const [streamArr, setStreamArr] = useState([]);
  const [curStateArr, setCurStateArr] = useState([]);
  const [perStateArr, setPerStateArr] = useState([]);
  const [langArr, setLangArr] = useState([]);
  const [bloodGrpArr, setBloodGrpArr] = useState([]);
  const [relshnshipArr, setRelshnshipArr] = useState([]);
  const [relgnArr, setRelgnArr] = useState([]);
  const [empTypArr, setEmpTypArr] = useState([]);
  const [empGradeArr, setEmpGradeArr] = useState([]);
  const [unitOfMsrArr, setUnitOfMsrArr] = useState([]);
  const handleApiError = useNavigateErrorHandler();
  const [maritalStArr, setMaritalStArr] = useState([]);
  const [visaTypArr, setVisaTypArr] = useState([]);
  const [visaNmArr, setVisaNmArr] = useState([]);
  const [bankNmArr, setBankNmArr] = useState([]);
  const [bankTypArr, setBankTypArr] = useState([]);
  const [impQueArr, setImpQueArr] = useState([]);
  const [impQues, setImpQues] = useState([]);
  const [certNmArr, setCertNmArr] = useState([]);
  const [certInstNmArr, setCertInstNmArr] = useState([]);
  const [isSameAsCurrent, setIsSameAsCurrent] = useState(false);
  const [offeredCand, setOfferedCand] = useState([]);
  const [lastUpdatedDateCand, setLastUpdatedDateCand] = useState(new Date());
  const isInitializedNewEmpRef = useRef(false);
  const [curEmpCode, setCurEmpCode] = useState('');
  const [curEmpPic, setCurEmpPic] = useState(false);
  const [isFileTooLarge, setIsFileTooLarge] = useState(false);
  const maxSizeOfDocs = useSelector((state) => state.tenantPreference?.maxSizeOfDocuments || 3);
  const [statesAvailable, setStatesAvailable] = useState(false);
  const [citiesAvailable, setCitiesAvailable] = useState(false);
  const [selectedEmpType, setSelectedEmpType] = useState(null);

  const [EmpExp, setEmpExp] = useState([]);
  const [EmpRef, setEmpRef] = useState([]);
  const [EmpEmrg, setEmpEmrg] = useState([]);
  const [EmpLang, setEmpLang] = useState([]);
  const [EmpWrk, setEmpWrk] = useState([]);
  const [EmpCert, setEmpCert] = useState([]);
  const [EmpVisa, setEmpVisa] = useState([]);
  const [EmpEdu, setEmpEdu] = useState([]);
  const [EmpBank, setEmpBank] = useState([]);
  const [EmpPass, setEmpPass] = useState([]);
  const [EmpFam, setEmpFam] = useState([]);
  const [EmpImpQ, setEmpImpQ] = useState([]);

  const [isSavingOnly, setIsSavingOnly] = useState(false);
  const [isSavingNext, setIsSavingNext] = useState(false);
  const [savingAction, setSavingAction] = useState(null); // null, 'saveOnly', or 'saveNext'
  const [isProfilePhotoRemoved, setIsProfilePhotoRemoved] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const openConfirmDialog = () => setConfirmOpen(true);
  const closeConfirmDialog = () => setConfirmOpen(false);

  // ---------------------------------------------------------------------------------------------------------------------------------
  const steps = [
    'Basic Details',
    'Personal & Family Details',
    'Address & Contact Details',
    'Education & Certification Details',
    'Passport & Visa Details',
    'Experience & Reference Details',
    'Bank Details',
    'Other Details',
  ];

  const stepsvalidator = [
    {
      label: 'Basic Details',
      fields: {
        candidate: '',
        ...(!isOnEmployeeForm && {
          empTyp: '',
          empGrade: '',
          dateOfJoin: '',
          designation: '',
        }),
      },
    },
    {
      label: 'Personal & Family Details',
      fields: {
        fname: '',
        lname: '',
        gender: '',
        email: '',
        mobno: '',
        panno: '',
        empFamilyRel: '',
      },
    },
    {
      label: 'Address & Contact Details',
      fields: {
        curAddLn1: '',
        curAddLn2: '',
        curAddCntr: '',
        curAddState: '',
        curAddCity: '',
        curAddLandLn: '',
        permAddLn1: '',
        permAddLn2: '',
        permAddCntr: '',
        permAddState: '',
        permAddCity: '',
        permAddLandLn: '',
        empEmrgncyContact: '',
      },
    },
    {
      label: 'Education & Certification Details',
      fields: {
        empEdu: '',
        empCert: '',
        empLang: '',
      },
    },
    {
      label: 'Passport & Visa Details',
      fields: {
        empPassport: '',
        empVisa: '',
      },
    },
    {
      label: 'Experience & Reference Details',
      fields: {
        empExp: '',
        empRef: '',
      },
    },
    {
      label: 'Bank Details',
      fields: {
        empBank: '',
      },
    },
    {
      label: 'Other Details',
      fields: {
        srcofhire: '',
        empRelWrkn: '',
      },
    },
  ];

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState();
  const [stepCompletionStatus, setStepCompletionStatus] = useState(
    new Array(steps.length).fill(null)
  );
  const [progress, Setprogress] = useState(0);
  const [isFinalStep, setIsFinalStep] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [switchState, setSwitchState] = useState({
    experience: false,
    passport: false,
    visa: false,
  });



  // --------------------------------------------------------------------------------------------------------------------------------------
  const yesNoArr = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ];

  const NewEmployeeSchema = Yup.object().shape({
    ...(activeStep >= 0 && {
      ...(!isOnEmployeeForm && {
        candidate: currentEmp ? Yup.object() : Yup.object().required('Candidate is required'),
        empTyp: Yup.object()
          .shape({
            masterId: Yup.number().required(),
            masterName: Yup.string().required(),
          })
          .nullable()
          .required('Employment type is required'),

        empGrade: Yup.lazy((value, { parent }) => {
          const empTypName = parent?.empTyp?.masterName;
          const isRequired = ['Freelance', 'Full-time Employment'].includes(empTypName);

          return isRequired
            ? Yup.object().required('Employment grade is required')
            : Yup.mixed().notRequired();
        }),
        dateOfJoin: Yup.date()
          .required('Date of joining is required')
          .typeError('Date of joining must be a valid date'),
        designation: Yup.object().required('Designation is required'),
      }),
    }),
    ...(activeStep >= 1 && {
      fname: Yup.string()
        .required('First name is required. For example: Rajesh')
        .max(100, 'First name must not exceed 100 characters. For example: Rajesh or Priya')
        .test(
          'no-spaces',
          'First name cannot be only blank spaces or start/end with blank spaces. For example: "Rajesh" is valid, but "  Rajesh  " is not.',
          (value) => value.trim() !== '' && value === value.trim()
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'First name cannot contain numbers or special characters. For example: "Rajesh" is valid, but "Rajesh123" or "Rajesh@#" is not.'
        ),
      mname: Yup.string()
        .max(100, 'Middle name must not exceed 100 characters. For example: Kumar')
        .test(
          'no-spaces-mid',
          'Middle name cannot be only blank spaces or start/end with blank spaces. For example: "Kumar" is valid, but "  Kumar  " is not.',
          (value) => {
            if (!value) return true;
            return value.trim() !== '' && value === value.trim();
          }
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'Middle name cannot contain numbers or special characters. For example: "Kumar" is valid, but "Kumar123" or "Kumar@#" is not.'
        ),
      lname: Yup.string()
        .required('Last name is required. For example: Gupta')
        .max(100, 'Last name must not exceed 100 characters. For example: Gupta or Sharma')
        .test(
          'no-spaces',
          'Last name cannot be only blank spaces or start/end with blank spaces. For example: "Gupta" is valid, but "  Gupta  " is not.',
          (value) => value.trim() !== '' && value === value.trim()
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'Last name cannot contain numbers or special characters. For example: "Gupta" is valid, but "Gupta123" or "Gupta@#" is not.'
        ),
      gender: Yup.object().required('Gender is required'),
      email: Yup.string()
        .required('Email is required')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Email must be a valid email address')
        .max(100, 'Email must not exceed 254 characters'),
      mobno: Yup.string()
        .required('Mobile number is required. For example: 9876543210')
        .max(12, 'Enter a valid mobile number. For example: 9876543210')
        .min(10, 'Enter a valid mobile number. For example: 9876543210')
        .test('phncode-required', 'Country Code is required', (value, context) => {
          // Arrow function
          const { phncode } = context.parent; // Extract phncode from context.parent
          if (!phncode) {
            return false;
          }
          return true; // If country code is valid
        }),
      aadharno: Yup.string().test(
        'is-valid-aadharno',
        'Aadhaar number is not valid (e.g., "234512345678")',
        (value) => {
          if (!value) return true; // Allow empty values
          return /^[0-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/.test(value);
        }
      ),
      panno: Yup.string()
        .notRequired()
        .test('is-valid-panno', 'PAN card number is not valid (e.g., "ABCDE1234F")', (value) => {
          if (!value) return true; // Allow empty values
          return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
        }),

      pfno: Yup.string().test(
        'is-valid-pfno',
        'PF(UAN) number is not valid (e.g., "123456789012" or "ABCDE123456F")',
        (value) => {
          if (!value) return true; // Allow empty values

          const uanPattern = /^\d{12}$/; // 12-digit number
          const pfPattern = /^[A-Z]{5}\d{6}[A-Z]$/; // e.g., ABCDE123456F

          return uanPattern.test(value) || pfPattern.test(value);
        }
      ),
      pranno: Yup.string().test(
        'is-valid-pranno',
        'PRAN number must be 12 digits long (e.g., "123456789012")',
        (value) => {
          if (!value) return true; // Allow empty values
          return value.length === 12 && /^[0-9]{12}$/.test(value);
        }
      ),
      linkedinLink: Yup.string()
        .notRequired()
        .test(
          'is-valid-url',
          'Enter a valid LinkedIn profile URL (e.g., "https://www.linkedin.com/in/firstname-lastname/")',
          (value) => {
            if (!value) return true;
            const regex =
              /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
            return regex.test(value) && value.includes('linkedin.com');
          }
        ),
      dateOfBirth: Yup.date().nullable().typeError('Date of birth must be a valid date'),
      placeOfBirth: Yup.string()
        .max(100, 'Place of birth must not exceed 100 characters')
        .test(
          'no-spaces',
          'Place of birth cannot be just spaces or start/end with blank spaces',
          (value) => {
            if (value === '') return true;
            return value.trim() !== '' && value === value.trim();
          }
        )
        .matches(/^[a-zA-Z\s]*$/, 'Place of birth cannot contain numbers or special characters'),
      nationality: Yup.string()
        .max(100, 'Nationality must not exceed 100 characters')
        .matches(/^[A-Za-z\s]*$/, 'Nationality must contain only letters'),
      height: Yup.number()
        .min(0, 'Height cannot be in negetive')
        .max(260, 'Height cannot be more then 260 cm'),
      weight: Yup.number()
        .min(0, 'Weight cannot be in negetive')
        .max(700, 'Weight cannot be more then 700 kg'),
    }),
    ...(activeStep >= 2 && {
      curAddLn1: Yup.string()
        .required('Current Address line 1 is required')
        .max(200, 'Current Address must not exceed 200 characters')
        .test(
          'no-spaces',
          'Current Address line 1 cannot be just spaces or start/end with blank spaces',
          (value) => value.trim() !== '' && value === value.trim()
        ),

      curAddLn2: Yup.string().max(100, 'Address Line 2 must be at most 100 characters'),

      curAddCntr: Yup.object().required('Permanent Country is required'),

      curAddCity: Yup.lazy((value) =>
        perCityArr.length === 0
          ? Yup.mixed().notRequired()
          : Yup.object().required('Permanent City is required')
      ),

      curAddState: Yup.lazy((value) =>
        perStateArr.length === 0
          ? Yup.mixed().notRequired()
          : Yup.object().required('Permanent State is required')
      ),

      curAddLandLn: Yup.string()
        .test('is-numeric', 'Land line number must be numeric (e.g., "0123456789")', (value) => {
          if (value === '') return true; // Allow empty values
          return /^\d+$/.test(value);
        })
        .test(
          'is-valid',
          'Land line number must be 10-11 digits and not all zeros (e.g., "0123456789")',
          (value) => {
            if (value === '') return true; // Allow empty values
            return !/^[0]+$/.test(value) && value.length >= 10 && value.length <= 11;
          }
        ),
      permAddLn1: Yup.string()
        .required('Permanent Address line 1 is required')
        .max(100, 'Permanent Address must not exceed 100 characters')
        .test(
          'no-spaces',
          'Permanent Address line 1 cannot be just spaces or start/end with blank spaces (e.g., "123 MG Road")',
          (value) => value.trim() !== '' && value === value.trim()
        ),

      permAddLn2: Yup.string().max(100, 'Permanent Address Line 2 must be at most 100 characters'),

      permAddCntr: Yup.object().required('Permanent Country is required'),

      permAddState: Yup.lazy((value) =>
        perStateArr.length === 0
          ? Yup.mixed().notRequired()
          : Yup.object().required('Permanent State is required')
      ),

      permAddCity: Yup.lazy((value) =>
        perCityArr.length === 0
          ? Yup.mixed().notRequired()
          : Yup.object().required('Permanent City is required')
      ),

      permAddLandLn: Yup.string()
        .test('is-numeric', 'Land line number must be numeric (e.g., "0123456789")', (value) => {
          if (value === '') return true;
          return /^\d+$/.test(value);
        })
        .test('is-valid', 'Land line number must be valid (e.g., "0123456789")', (value) => {
          if (value === '') return true;
          return !/^[0]+$/.test(value) && value.length >= 10 && value.length <= 11;
        }),
    }),
    ...(activeStep >= 7 && {
      srcofhire: Yup.object().required('Source of hire is required'),
    }),
    ...(activeStep >= 4 && {
      empPassport: Yup.array()
        .of(
          Yup.object().shape({
            passNo: Yup.string()
              .required('Passport number is required')
              .matches(
                /^[A-Z0-9]{6,9}$/,
                'Passport must be 6–9 characters long, using letters and digits (e.g., A1234567, AB123456)'
              ),
            issuePlace: Yup.object().required('Place of issue is required'),
            issueDt: Yup.date().nullable().typeError('Issue date must be a valid date'),
            expiryDt: Yup.date()
              .nullable()
              .typeError('Expiry date must be a valid date')
              .min(Yup.ref('issueDt'), 'Expiry Date should be greater than issued date'),
          })
        )
        .test(
          'unique-passport',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.passNo;
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empPassport[${errors[0]}].passNo`, // Point to the first duplicate found
                message: 'You have already added this passport details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 2 && {
      empEmrgncyContact: Yup.array()
        .of(
          Yup.object().shape({
            name: Yup.string()
              .required('Full name is required (e.g., "Rakesh Mohan Gupta")')
              .max(100, 'Full name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Full name cannot be just spaces or start/end with blank spaces',
                (value) => value && value.trim() !== '' && value === value.trim()
              )
              .matches(/^[a-zA-Z\s]*$/, 'Full name cannot contain numbers or special characters'),

            email: Yup.string()
              .required('Email is required')
              .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Email must be a valid email address')
              .max(100, 'Email must not exceed 100 characters'),

            mobno: Yup.string()
              .required('Contact Number is required')
              .min(10, 'Enter valid Contact Number')
              .max(12, 'Enter valid Contact Number'),

            curAddCntr: Yup.object().required('Country is required'),
            curAddZip: Yup.string().max(6, 'Zip code must not exceed 6 characters'),

            ...(statesAvailable && {
              curAddState:
                countryArr.length === 0
                  ? Yup.mixed().notRequired()
                  : Yup.object().required('State is required'),
            }),
            ...(citiesAvailable && {
              curAddCity:
                countryArr.length === 0
                  ? Yup.mixed().notRequired()
                  : Yup.object().required('City is required'),
            }),
          })
        )
        .test(
          'unique-emrgncy',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const mobnoSet = new Set();
            const errors = [];
            const mobnoErrors = [];
            value.forEach((entry, index) => {
              const passNo = entry.name?.toLowerCase();
              const mobno = entry.mobno?.toLowerCase();
              if (passNo && seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
              if (mobno && mobnoSet.has(mobno)) {
                mobnoErrors.push(index);
              } else if (mobno) {
                mobnoSet.add(mobno);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empEmrgncyContact[${errors[0]}].name`, // Point to the first duplicate found
                message: 'You have already added this Emergency contact details.',
              });
            }
            if (mobnoErrors.length) {
              // Return false to indicate that validation failed for mobno
              return context.createError({
                path: `empEmrgncyContact[${mobnoErrors[0]}].mobno`,
                message: 'You have already added this Emergency contact mobile number.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 3 && {
      empCert: Yup.array()
        .of(
          Yup.object().shape({
            certiNm: Yup.string()
              .required('Certification name is required')
              .max(100, 'Certification name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Certification name cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            certfromDate: Yup.date().nullable().typeError('From date must be a valid date'),
            certtoDate: Yup.date()
              .nullable()
              .typeError('To date must be a valid date')
              .min(Yup.ref('certfromDate'), 'To Date should be greater than from date'),
          })
        )
        .test(
          'unique-certification',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const certTitle = entry.certiNm;
              const instituteTitle = entry.certiInstiNm;
              if (!certTitle || !instituteTitle) return;
              const identifier = `${certTitle}-${instituteTitle}`;
              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empCert[${errors[0]}].certiNm`, // Point to the first duplicate found
                message:
                  'You have already selected this certification and institute in your certification details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 5 && {
      empExp: Yup.array()
        .of(
          Yup.object().shape({
            compNm: Yup.string()
              .required('Employer Name is required (e.g., "Infosys", "Wipro")')
              .max(100, 'Employer Name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Employer name cannot be just spaces or start/end with blank spaces (e.g., "Infosys", "Wipro")',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            designation: Yup.object().required('Designation is required'),
            ctc: Yup.number()
              .min(0, 'CTC cannot be in negetive')
              .max(2000000000, 'CTC cannot be more then 2000000000')
              .when('country', {
                is: (val) => val !== null,
                then: (schema) =>
                  schema.required('CTC is required').moreThan(0, 'CTC must be greater than 0'),
                otherwise: (schema) => schema.nullable(),
              })
              .test(
                'noEOrSign', // type of the validator (should be unique)
                "Number had an 'e' or sign.", // error message
                (value) => typeof value === 'number' && !/[eE+-]/.test(value.toString())
              )
              .test('phncode-required', 'CTC currency is required', (value, context) => {
                // Arrow function
                const { ctccurncy } = context.parent; // Extract phncode from context.parent
                if (value && !ctccurncy) {
                  // If both mobile number and country code are missing
                  return false;
                }
                return true; // If country code is valid
              }),
            expfromDate: Yup.date()
              .required('From date is required')
              .typeError('From date must be a valid date')
              .test('no-future-date', 'From date cannot be a future date', (value, context) => {
                if (!value) return true;
                return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
              })
              .test('less-than-to-date', 'From date must be less than To date', (value, context) => {
                if (!value) return true;
                const toDate = context.parent.exptoDate;
                if (!toDate) return true;
                return new Date(value).setHours(0, 0, 0, 0) < new Date(toDate).setHours(0, 0, 0, 0);
              }),
            exptoDate: Yup.date()
              .nullable()
              .typeError('To date must be a valid date')
              .test('greater-than-from-date', 'To date must be greater than From date', (value, context) => {
                if (!value) return true;
                const fromDate = context.parent.expfromDate;
                if (!fromDate) return true;
                return new Date(value).setHours(0, 0, 0, 0) > new Date(fromDate).setHours(0, 0, 0, 0);
              })
              .test('min-date-one-month', 'To Date should be at least 1 month after From Date', (value, context) => {
                if (!value) return true;
                const fromDate = context.parent.expfromDate;
                if (!fromDate) return true;
                const from = new Date(fromDate);
                const to = new Date(value);
                const oneMonthLater = new Date(from);
                oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
                return to.setHours(0, 0, 0, 0) >= oneMonthLater.setHours(0, 0, 0, 0);
              })
              .when('currentywrkng', {
                is: (val) => val === true,
                then: (schema) =>
                  schema
                    .notRequired()
                    .test('max-current-plus-3-months', 'To date cannot be more than 3 months in the future', (value) => {
                      if (!value) return true;
                      const maxAllowedDate = new Date();
                      maxAllowedDate.setMonth(maxAllowedDate.getMonth() + 3);
                      return new Date(value).setHours(0, 0, 0, 0) <= maxAllowedDate.setHours(0, 0, 0, 0);
                    }),
                otherwise: (schema) =>
                  schema
                    .required('To date is required')
                    .test('max-today', 'To date cannot be in the future', (value) => {
                      if (!value) return true;
                      return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
                    }),
              }),
          })
        )
        // Overlapping date ranges validation on the whole array
        .test('no-overlapping-dates', function (empExpArray) {
          if (!empExpArray || empExpArray.length < 2) return true;

          const { createError } = this;

          const ranges = empExpArray
            .map((exp, idx) => {
              const from = exp.expfromDate ? new Date(exp.expfromDate).getTime() : null;
              const to = exp.exptoDate ? new Date(exp.exptoDate).getTime() : null;
              if (from === null || to === null) return null;
              return { idx, from, to };
            })
            .filter(Boolean);

          for (let i = 0; i < ranges.length; i += 1) {
            for (let j = i + 1; j < ranges.length; j += 1) {
              const r1 = ranges[i];
              const r2 = ranges[j];
              // Check if ranges overlap (including touching dates)
              if (r1.from <= r2.to && r2.from <= r1.to) {
                return createError({
                  path: `empExp[${r1.idx}].expfromDate`,
                  message: 'This experience overlaps with another experience date range.',
                });
              }
            }
          }

          return true;
        })
        .test(
          'unique-employer-designation',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const company = entry.compNm;
              const desgn = entry.designation?.designationName;
              if (!company || !desgn) return;
              const identifier = `${company}-${desgn}`;
              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empExp[${errors[0]}].compNm`, // Point to the first duplicate found
                message:
                  'You have already selected this employer and designation in your experience details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 3 && {
      empEdu: Yup.array()
        .of(
          Yup.object().shape({
            university: Yup.object().required('Institute/University is required'),
            qualtype: Yup.object().required('Qualification type is required'),
            qualification: Yup.object().required('Qualification is required'),
            stream: Yup.object().required('Qualification Stream is required'),
            candpercnt: Yup.number()
              .min(0, 'Percentage cannot be less than 0%')
              .max(100, 'Percentage cannot be greater than 100%')
              .typeError('Percentage must be a valid number')
              .test(
                'max-2-decimals',
                'Enter percentage with a maximum of 2 decimal places (e.g., 89.75)',
                (value) => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
              ),

            candcgpa: Yup.number()
              .min(0, 'CGPA cannot be less than 0')
              .max(10, 'CGPA cannot be greater than 10')
              .typeError('CGPA must be a valid number')
              .test(
                'max-2-decimals',
                'Enter CGPA with a maximum of 2 decimal places (e.g., 8.25)',
                (value) => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
              ),

            edufromDate: Yup.date()
              .required('From date is required')
              .typeError('From date must be a valid date'),
            edutoDate: Yup.date()
              .required('To date is required')
              .typeError('To date must be a valid date')
              .min(Yup.ref('edufromDate'), '"To Date" should be greater than "From Date"')
              .when('currentypurs', {
                is: true, // If "currently pursuing" is true
                then: () => Yup.date().notRequired(), // Skip validation when pursuing
                otherwise: () =>
                  Yup.date()
                    .required('To date is required') // Make "To Date" required when not pursuing
                    .min(Yup.ref('edufromDate'), '"To Date" should be after "From Date"') // Ensure "To Date" is after "From Date"
                    .test(
                      'min-date-one-year',
                      '"To Date" should be at least 1 year greater than "From Date"',
                      function (value) {
                        if (!value) return true;
                        // eslint-disable-next-line react/no-this-in-sfc
                        const fromDate = this.parent.edufromDate; // Get "edufromDate" from parent context

                        // If either From Date or To Date is missing, return true (skip validation)
                        if (!fromDate || !value) return true;

                        // Convert to Date objects
                        const from = new Date(fromDate);
                        const to = new Date(value);

                        // Validate that To Date is at least 1 year after From Date
                        const oneYearLater = new Date(from.setFullYear(from.getFullYear() + 1));

                        return to >= oneYearLater; // Ensure To Date is at least 1 year greater than From Date
                      }
                    ),
              })
              .test(
                'min-date-one-year',
                '"To Date" should be at least 1 year greater than "From Date"',
                (value, context) => {
                  const edufromDate = context.parent.edufromDate;
                  if (!edufromDate || !value) {
                    return true; // skip validation if from date or to date is not set
                  }
                  const fromDate = new Date(edufromDate);
                  const toDate = new Date(value);
                  const oneYearLater = new Date(fromDate.setFullYear(fromDate.getFullYear() + 1));
                  return toDate >= oneYearLater;
                }
              ),
          })
        )
        .test(
          'unique-qualification-stream',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const qualificationTitle = entry.qualification?.qualificationTitle;
              const streamTitle = entry.stream?.streamTitle;
              if (!qualificationTitle || !streamTitle) return;
              const identifier = `${qualificationTitle}-${streamTitle}`;
              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empEdu[${errors[0]}].qualification`, // Point to the first duplicate found
                message:
                  'You have already selected this qualification and stream in your education details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 5 && {
      empRef: Yup.array()
        .of(
          Yup.object().shape({
            refNm: Yup.string()
              .required('Reference name is required (e.g., "Rajesh Sahani")')
              .max(100, 'Reference must not exceed 100 characters')
              .test(
                'no-spaces',
                'Reference name cannot be just spaces or start/end with blank spaces (e.g., "Rajesh Sahani")',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(
                /^[a-zA-Z\s]*$/,
                'Reference name cannot contain numbers or special characters'
              ),
            refOrgNm: Yup.string()
              .required('Reference organization is required')
              .max(
                100,
                'Reference organization must not exceed 100 characters (e.g., "TCS", "Infosys")'
              )
              .test(
                'no-spaces',
                'Reference organization cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            refdesig: Yup.object().required('Reference designation is required'),
            refEmail: Yup.string()
              .required('Reference email is required (e.g., "example@gmail.com")')
              .max(100, 'Email must not exceed 100 characters')
              .matches(
                /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
                'Email must be a valid email address (e.g., "john.doe@gmail.com")'
              ),

            refContact: Yup.string().test(
              'is-valid-length',
              'Enter valid mobile number',
              (value) => {
                if (!value) return true; // If the field is empty, don't validate
                return value.length >= 10 && value.length <= 12;
              }
            ),
          })
        )
        .test(
          'unique-reference',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const refNm = entry.refNm;
              const refOrg = entry.refOrgNm;
              if (!refNm || !refOrg) return;
              const identifier = `${refNm}-${refOrg}`;
              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empRef[${errors[0]}].refNm`, // Point to the first duplicate found
                message: 'You have already added this reference in your reference details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 3 && {
      empLang: Yup.array()
        .of(
          Yup.object().shape({
            lang: Yup.object().required('Language is required'),
            read: Yup.string().required('Answer is required'),
            speak: Yup.string().required('Answer is required'),
            write: Yup.string().required('Answer is required'),
          })
        )
        .test('unique-lang', null, function (value) {
          if (!value) return true;

          const seen = new Set();
          const errors = [];

          value.forEach((entry, index) => {
            const langName = entry.lang?.languagesName; // <-- FIXED this line
            if (!langName) return;

            if (seen.has(langName)) {
              errors.push(index);
            } else {
              seen.add(langName);
            }
          });

          if (errors.length > 0) {
            // eslint-disable-next-line react/no-this-in-sfc
            return this.createError({
              path: `empLang[${errors[0]}].lang`, // <-- First duplicate field
              message: 'You have already added this language details.',
            });
          }

          return true;
        }),
    }),
    ...(activeStep >= 1 && {
      empFamilyRel: Yup.array()
        .of(
          Yup.object().shape({
            relationship: Yup.object().required('Relationship is required'),
            name: Yup.string()
              .required('Full Name is required (e.g., "Rajech Soma Sahani")')
              .max(100, 'Full Name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Full name cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[a-zA-Z\s]*$/, 'Full name cannot contain numbers or special characters'),
            passNo: Yup.string().matches(
              /^[A-Z0-9]{6,9}$/,
              'Passport must be 6–9 characters long, using letters and digits (e.g., A1234567, AB123456)'
            ),
          })
        )
        .test(
          'unique-famRel',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.name?.toLowerCase();
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empFamilyRel[${errors[0]}].name`, // Point to the first duplicate found
                message: 'You have already added this family member details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 4 && {
      empVisa: Yup.array()
        .of(
          Yup.object().shape({
            visaNo: Yup.string()
              .required('Visa number is required (e.g., "A1234567 ")')
              // eslint-disable-next-line prefer-arrow-callback
              .test('len-check', 'Visa number is not valid.', function (value) {
                if (!value) return true;
                return value.length >= 8 && value.length <= 10;
              }),
            visaTyp: Yup.object().required('Visa type is required'),
            forCntry: Yup.object().required('Country is required'),
            issueDt: Yup.date().nullable().typeError('Issue date must be a valid date'),
            expiryDt: Yup.date()
              .nullable()
              .typeError('Expiry date must be a valid date')
              .min(Yup.ref('issueDt'), 'Expiry Date should be greater than issued date')
              .test(
                'min-duration',
                'Expiry Date must be at least 15 days after the Issue Date',
                (value, context) => {
                  const issueDt = context.parent.issueDt;
                  if (!issueDt || !value) return true; // Skip validation if dates are not set
                  const issueDate = new Date(issueDt);
                  const expiryDate = new Date(value);
                  const minDuration = 15 * 24 * 60 * 60 * 1000; // 15 days in milliseconds
                  return expiryDate.getTime() - issueDate.getTime() >= minDuration;
                }
              ),
          })
        )
        .test(
          'unique-visa',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.visaNo;
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empVisa[${errors[0]}].visaNo`, // Point to the first duplicate found
                message: 'You have already added this visa details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 6 && {
      empBank: Yup.array()
        .of(
          Yup.object().shape({
            bankNm: Yup.object().required('Bank name is required. Example: "State Bank of India"'),
            branch: Yup.string()
              .required('Bank branch is required. Example: "MG Road Branch"')
              .max(100, 'Bank branch must not exceed 100 characters. Example: "MG Road Branch"')
              .matches(
                /^[a-zA-Z\s]*$/,
                'Bank branch name cannot contain numbers or special characters. Example: "MG Road Branch"'
              )
              .test(
                'no-spaces',
                'Bank branch cannot be just spaces or start/end with blank spaces. Example: "MG Road Branch"',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            accNm: Yup.string()
              .required('Account holder name is required. Example: "Rajesh Sahani"')
              .max(
                100,
                'Account holder name must not exceed 100 characters. Example: "Rajesh Sahani"'
              )
              .test(
                'no-spaces',
                'Account holder name cannot be just spaces or start/end with blank spaces. Example: "Rajesh Sahani"',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(
                /^[a-zA-Z\s]*$/,
                'Account holder name cannot contain numbers or special characters. Example: "Rajesh Sahani"'
              ),
            accNo: Yup.string()
              .required('Account number is required. Example: "123456789"')
              .test(
                'no-spaces',
                'Account number cannot be just spaces or start/end with blank spaces. Example: "123456789"',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[0-9]{9,18}$/, 'Account number is not valid. Example: "123456789"'),
            accTyp: Yup.object().required(
              'Account type is required. Example: "Savings" or "Current"'
            ),
            ifsc: Yup.string()
              .required('IFSC code is required. Example: "SBIN0000001"')
              .test(
                'no-spaces',
                'IFSC code cannot be just spaces or start/end with blank spaces. Example: "SBIN0000001"',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'IFSC code is not valid. Example: "SBIN0000001"'),
            swiftCd: Yup.string().test(
              'is-valid-swiftno',
              'SWIFT code is not valid. Example: "SBININBB"',
              (value) => {
                if (!value) return true;
                return /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value);
              }
            ),
            startDate: Yup.date()
              .required('Start date is required')
              .typeError('Start date must be a valid date'),
            endDate: Yup.date()
              .nullable()
              .typeError('End date must be a valid date')
              .min(Yup.ref('startDate'), 'End Date should be greater than Start date'),
          })
        )
        .test(
          'unique-bank',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.accNo;
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empBank[${errors[0]}].accNo`, // Point to the first duplicate found
                message: 'You have already added this bank details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 7 && {
      empRelWrkn: Yup.array()
        .of(
          Yup.object().shape({
            name: Yup.string()
              .required('Full name is required')
              .max(100, 'Full name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Full name cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[a-zA-Z\s]*$/, 'Full name cannot contain numbers or special characters'),
            relationship: Yup.object().required('Relationship is required'),
            refdesig: Yup.object().required('Designation is required'),
          })
        )
        .test(
          'unique-relerkn',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.name?.toLowerCase();
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empRelWrkn[${errors[0]}].name`, // Point to the first duplicate found
                message: 'You have already added this relation details.',
              });
            }
            return true;
          }
        ),
    }),
  });
  const [openDialog, setOpenDialog] = useState(false);

  const getEduDtl = useCallback(() => {
    if (currentEmpEdu) {
      const e = currentEmpEdu.map((cEdu) => ({
        eduSrno: cEdu.id,
        university: cEdu.university,
        othrUni: cEdu.universityName,
        qualtype: cEdu.qualificationTypeId,
        qualification: cEdu.qualification,
        currentypurs: cEdu.currentlyPursuing,
        stream: cEdu.stream,
        candpercnt: cEdu.percentage,
        candcgpa: cEdu.cgpa,
        edufromDate: cEdu.durationFrom ? new Date(cEdu.durationFrom) : null,
        edutoDate: cEdu.durationTo ? new Date(cEdu.durationTo) : null,
      }));
      setEmpEdu(e);
    }
  }, [currentEmpEdu]);
  const getExpDtl = useCallback(() => {
    if (currentEmpExp) {
      const e = currentEmpExp.map((eExp) => ({
        expSrno: eExp.id,
        compNm: eExp.company,
        designation: eExp.designation,
        currentywrkng: eExp.currentlyWorking,
        ctc: decryptData(eExp.ctc),
        ctccurncy: eExp.ctcCurrency,
        country: eExp.country,
        expfromDate: eExp.durationFrom ? new Date(eExp.durationFrom) : null,
        exptoDate: eExp.durationTo ? new Date(eExp.durationTo) : null,
      }));
      setEmpExp(e);
    }

    // added the condition for experience switch
    if (currentEmpExp) {
      if (currentEmpExp.length > 0) {
        setSwitchState((prevState) => ({
          ...prevState,
          experience: true, // Set experience to true if length > 0
        }));
      } else {
        setSwitchState((prevState) => ({
          ...prevState,
          experience: false, // Set experience to false if length is 0
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmpExp]);
  const getRefDtl = useCallback(() => {
    if (currentEmpRef) {
      const e = currentEmpRef.map((eRef) => ({
        refSrno: eRef.employeeReferenceId,
        refNm: eRef.empReferenceName,
        refOrgNm: eRef.empReferenceOrganization,
        refdesig: eRef.designationId,
        refEmail: decryptData(eRef.empReferenceEmail),
        refContact: decryptData(eRef.empReferenceContactNumber),
      }));
      setEmpRef(e);
    }
  }, [currentEmpRef]);
  const getEmrgDtl = useCallback(() => {
    if (currentEmpEmrg) {
      const e = currentEmpEmrg.map((eEmer) => ({
        cntctSrno: eEmer.emergencyContactId,
        name: eEmer.fullName,
        relationship: eEmer.relationId,
        email: decryptData(eEmer.email),
        mobno: decryptData(eEmer.mobileNumber),
        curAddLn1: eEmer.address1,
        curAddLn2: eEmer.address2,
        curAddCntr: eEmer.countriesId,
        curAddState: eEmer.stateId,
        curAddCity: eEmer.citiesId,
        curAddLandMrk: eEmer.landmark,
        curAddZip: eEmer.zipcode,
      }));
      setEmpEmrg(e);
    }
  }, [currentEmpEmrg]);
  const getLangDtl = useCallback(() => {
    if (currentEmpLang) {
      const e = currentEmpLang.map((eExp) => ({
        langSrno: eExp.id,
        lang: eExp.language,
        read: eExp.read,
        speak: eExp.speak,
        write: eExp.write,
      }));
      setEmpLang(e);
    }
  }, [currentEmpLang]);
  const getWrkDtl = useCallback(() => {
    if (currentEmpWrk) {
      const e = currentEmpWrk.map((eExp) => ({
        cntctSrno: eExp.id,
        name: eExp.relEmpName,
        relationship: eExp.relationshipId,
        curAddCntr: eExp.curAddCntr,
        curAddState: eExp.curAddState,
        curAddCity: eExp.curAddCity,
        refdesig: eExp.designationId,
      }));
      setEmpWrk(e);
    }
  }, [currentEmpWrk]);
  const getCertDtl = useCallback(() => {
    if (currentEmpCert) {
      const e = currentEmpCert.map((eExp) => ({
        cerSrno: eExp.employeeCertificationId,
        certiNm: eExp.certificationName,
        certiInstiNm: eExp.instituteName,
        certfromDate: eExp.durationFrom ? new Date(eExp.durationFrom) : null,
        certtoDate: eExp.durationTo ? new Date(eExp.durationTo) : null,
      }));
      setEmpCert(e);
    }
  }, [currentEmpCert]);
  const getVisaDtl = useCallback(() => {
    if (currentEmpVisa) {
      const e = currentEmpVisa.map((eExp) => ({
        visaSrno: eExp.visaDetailsId,
        visaNo: decryptData(eExp.visaNumber),
        visaTyp: eExp.visaTypeId,
        visaNm: eExp.visaNameId,
        placeOfissue: eExp.placeOfIssue,
        forCntry: eExp.visaForCountry,
        issueDt: eExp.dateOfIssue ? new Date(eExp.dateOfIssue) : null,
        expiryDt: eExp.dateOfExpiry ? new Date(eExp.dateOfExpiry) : null,
      }));
      setEmpVisa(e);
    }

    // added the condition for experience switch
    if (currentEmpVisa) {
      if (currentEmpVisa.length > 0) {
        setSwitchState((prevState) => ({
          ...prevState,
          visa: true, // Set experience to true if length > 0
        }));
      } else {
        setSwitchState((prevState) => ({
          ...prevState,
          visa: false, // Set experience to false if length is 0
        }));
      }
    }
  }, [currentEmpVisa]);
  const getBankDtl = useCallback(() => {
    if (currentEmpBank) {
      const e = currentEmpBank.map((eExp) => ({
        bankSrno: eExp.bankDetailsId,
        bankNm: eExp.bankName,
        branch: eExp.branch,
        accNm: eExp.accountName,
        accNo: decryptData(eExp.accountNumber),
        accTyp: eExp.accountType,
        ifsc: decryptData(eExp.ifsc),
        swiftCd: decryptData(eExp.swiftCode),
        startDate: eExp.startDate ? new Date(eExp.startDate) : null,
        endDate: eExp.endDate ? new Date(eExp.endDate) : null,
      }));
      setEmpBank(e);
    }
  }, [currentEmpBank]);
  const getPassDtl = useCallback(() => {
    if (currentEmpPass) {
      const e = currentEmpPass.map((eExp) => ({
        passSrno: eExp.empPassportId,
        passNo: decryptData(eExp.passportNumber),
        issuePlace: eExp.placeOfIssue,
        issueDt: eExp.dateOfIssue ? new Date(eExp.dateOfIssue) : null,
        expiryDt: eExp.dateOfExpiry ? new Date(eExp.dateOfExpiry) : null,
        ecnrStamp: eExp.ecnrstampedName,
      }));
      setEmpPass(e);
    }

    // added the condition for experience switch
    if (currentEmpPass) {
      if (currentEmpPass.length > 0) {
        setSwitchState((prevState) => ({
          ...prevState,
          passport: true, // Set experience to true if length > 0
        }));
      } else {
        setSwitchState((prevState) => ({
          ...prevState,
          passport: false, // Set experience to false if length is 0
        }));
      }
    }
  }, [currentEmpPass]);
  const getFamDtl = useCallback(() => {
    if (currentEmpFam) {
      const e = currentEmpFam.map((eFam) => ({
        relSrno: eFam.familyRelationId,
        name: eFam.relativeName,
        relationship: eFam.relationship,
        dob: eFam.dateOfBirth ? new Date(eFam.dateOfBirth) : null,
        isAlive: eFam.isAlive,
        passNo: decryptData(eFam.passportNumber),
      }));
      setEmpFam(e);
    }
  }, [currentEmpFam]);
  const getImpQDtl = useCallback(() => {
    if (currentEmpImpQ && currentEmpImpQ.length > 0) {
      if (impQueArr && impQueArr.length > 0) {
        const merged = impQueArr.map((masterQ) => {
          const mId = masterQ.id || masterQ.masterId;
          const found = currentEmpImpQ.find((item) => {
            const itemQId = typeof item.questionId === 'object'
              ? (item.questionId?.id || item.questionId?.masterId)
              : item.questionId;
            return itemQId === mId;
          });
          if (found) {
            return {
              iqSrno: found.empImpQueid,
              impQue: found.questionId || masterQ,
              ans: found.answer || 'No',
              ansComment: found.ansDetails || '',
            };
          }
          return {
            iqSrno: 0,
            impQue: masterQ,
            ans: (masterQ.ansType && masterQ.ansType.toLowerCase() === 'yes') ? 'Yes' : 'No',
            ansComment: '',
          };
        });
        setEmpImpQ(merged);
      } else {
        const e = currentEmpImpQ.map((eExp) => ({
          iqSrno: eExp.empImpQueid,
          impQue: eExp.questionId,
          ans: eExp.answer || 'No',
          ansComment: eExp.ansDetails || '',
        }));
        setEmpImpQ(e);
      }
    }
  }, [currentEmpImpQ, impQueArr]);

  useEffect(() => {
    getEmrgDtl();
    getEduDtl();
    getLangDtl();
    getExpDtl();
    getCertDtl();
    getRefDtl();
    getWrkDtl();
    getVisaDtl();
    getBankDtl();
    getPassDtl();
    getFamDtl();
    getImpQDtl();
  }, [
    getEmrgDtl,
    getLangDtl,
    getWrkDtl,
    getEduDtl,
    getVisaDtl,
    getBankDtl,
    getPassDtl,
    getExpDtl,
    getFamDtl,
    getCertDtl,
    getRefDtl,
    getImpQDtl,
    currentEmpFam,
    currentEmpPass,
    currentEmpBank,
    currentEmpEdu,
    currentEmpVisa,
    currentEmpCert,
    currentEmpWrk,
    currentEmpLang,
    currentEmpEmrg,
    currentEmpRef,
    currentEmpExp,
    currentEmp,
    currentEmpImpQ,
  ]);


  const candObj = candidateData?.candidate || selectedCandidate;

  const defaultValues = useMemo(
    () => ({
      candidate: selectedCandidate || candidateData?.candidate || null,
      avatarUrl:
        profilePhotoUrl ||
        (typeof currentEmp?.profilePhoto === 'string' &&
          (currentEmp.profilePhoto.startsWith('http://') ||
            currentEmp.profilePhoto.startsWith('https://') ||
            currentEmp.profilePhoto.startsWith('data:'))
          ? currentEmp.profilePhoto
          : candObj?.profilePhotoUrl || null),
      empTyp: currentEmp?.employeeTypeId || null,
      empGrade: currentEmp?.empGradeId || null,
      empCode: decryptData(currentEmp?.employeeCode) || '',
      dateOfJoin: currentEmp?.dateOfJoining ? new Date(currentEmp.dateOfJoining) : new Date(),
      designation: currentEmp?.designationId || null,
      fname: currentEmp?.firstName || candObj?.firstName || '',
      nameTitle: currentEmp?.titleId || candObj?.nameTitle || null,
      mname: currentEmp?.middleName || candObj?.middleName || '',
      lname: currentEmp?.lastName || candObj?.lastName || '',
      dateOfBirth: currentEmp?.dateOfBirth ? new Date(currentEmp.dateOfBirth) : new Date(),
      placeOfBirth: currentEmp?.placeOfBirth || '',
      gender: currentEmp?.genderId || candObj?.gender || null,
      religion: currentEmp?.religionId || null,
      maritalStatus: currentEmp?.maritalStatusId || null,
      nationality: currentEmp?.nationality || '',
      bloodGrp: currentEmp?.bloodGroupId || null,
      height: currentEmp?.height || 0.0,
      unitOfHeight: currentEmp?.unitOfMeasureHeightId || null,
      weight: currentEmp?.weight || 0.0,
      unitOfWeight: currentEmp?.unitOfMeasureWeightId || null,
      email: decryptData(currentEmp?.email) || (candObj?.email ? decryptData(candObj.email) : ''),
      phncode: currentEmp?.mobPhoneCode || candObj?.mobPhoneCode || null,
      mobno: decryptData(currentEmp?.mobileNumber) || (candObj?.mobileNumber ? decryptData(candObj.mobileNumber) : ''),
      panno: decryptData(currentEmp?.pan) || (candObj?.uniqueNoType !== 'AADHAR' && candObj?.panNo ? decryptData(candObj.panNo) : ''),
      aadharno: decryptData(currentEmp?.aadharNumber) || (candObj?.uniqueNoType === 'AADHAR' && candObj?.panNo ? decryptData(candObj.panNo) : ''),
      pfno: decryptData(currentEmp?.uan) || '',
      pranno: decryptData(currentEmp?.pran) || '',
      linkedinLink: currentEmp?.linkedinLink || candObj?.linkedinUrl || '',
      isInternationalWrkr: currentEmp?.internationalWorker || false,
      ofclEmail: decryptData(currentEmp?.ofclEmail) || '',
      isdirector: currentEmp?.director || false,
      curAddLn1: currentEmp?.presentAddress1 || '',
      curAddLn2: currentEmp?.presentAddress2 || '',
      curAddCntr: currentEmp?.presentCountrIdy || candObj?.currentLocationCity?.stateId?.countryId || null,
      curAddState: currentEmp?.presentStateId || candObj?.currentLocationCity?.stateId || null,
      curAddCity: currentEmp?.presentCityId || candObj?.currentLocationCity || null,
      curAddLandMrk: currentEmp?.presentLandmark || '',
      curAddZip: currentEmp?.presentZipcode || '',
      curAddLandLn: currentEmp?.presentLandline || '',
      permAddLn1: currentEmp?.permanentAddress1 || '',
      permAddLn2: currentEmp?.permanentAddress2 || '',
      permAddCntr: currentEmp?.permAddCntr || null,
      permAddState: currentEmp?.permAddState || null,
      permAddCity: currentEmp?.permAddCity || null,
      permAddLandMrk: currentEmp?.permanentLandmark || '',
      permAddZip: currentEmp?.permanentZipcode || '',
      permAddLandLn: currentEmp?.permanentLandline || '',
      srcofhireNm: currentEmp?.srcofhireNm || candObj?.sourceOfHireName || '',
      srcofhire: currentEmp?.sourceOfHireId || candObj?.sourceOfHire || null,
      empPassport: currentEmpPass ? EmpPass : [],
      empEmrgncyContact: currentEmpEmrg ? EmpEmrg : [],
      empCert: currentEmpCert ? EmpCert : [],
      empEdu: currentEmpEdu ? EmpEdu : [],
      empExp: currentEmpExp ? EmpExp : [],
      empLang: currentEmpLang ? EmpLang : [],
      empRef: currentEmpRef ? EmpRef : [],
      empFamilyRel: currentEmpFam ? EmpFam : [],
      empVisa: currentEmpVisa ? EmpVisa : [],
      empBank: currentEmpBank ? EmpBank : [],
      empRelWrkn: currentEmpWrk ? EmpWrk : [],
      impQuesC: currentEmpImpQ ? EmpImpQ : impQues,
      startDate: new Date(),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      currentEmpFam,
      currentEmpPass,
      currentEmpBank,
      currentEmpEdu,
      currentEmpVisa,
      currentEmpCert,
      currentEmpWrk,
      currentEmpLang,
      currentEmpEmrg,
      currentEmpRef,
      currentEmpExp,
      currentEmp,
      currentEmpImpQ,
      EmpFam,
      EmpPass,
      EmpBank,
      EmpEdu,
      EmpVisa,
      EmpCert,
      EmpWrk,
      EmpLang,
      EmpEmrg,
      EmpRef,
      EmpExp,
      impQues,
      EmpImpQ,
      profilePhotoUrl,
      candidateData,
      selectedCandidate,
    ]
  );

  console.log("in the Employee Replica File.... 4")

  const methods = useForm({
    resolver: yupResolver(NewEmployeeSchema),
    mode: 'onChange',
    shouldUnregister: false,
    defaultValues,
  });
  const {
    control,
    handleSubmit,
    watch,
    resetField,
    getValues,
    setValue,
    reset,
    formState: { errors },
    trigger,
  } = methods;

  const impQuesData = useCallback(() => {
    if (impQueArr && impQueArr.length > 0) {
      if (!currentEmp) {
        const e = impQueArr.map((impQ) => ({
          iqSrno: 0,
          impQue: impQ,
          ans: (impQ.ansType && impQ.ansType.toLowerCase() === 'yes') ? 'Yes' : 'No',
          ansComment: '',
        }));
        setImpQues(e);
        setValue('impQuesC', e);
      } else if (currentEmpImpQ && currentEmpImpQ.length > 0) {
        getImpQDtl();
      }
    }
  }, [currentEmp, currentEmpImpQ, getImpQDtl, impQueArr, setValue]);

  useEffect(
    () => {
      // If impQueArr is not empty, call impQuesData to set the initial state
      impQuesData();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [impQuesData, impQueArr]
  );

  useEffect(() => {
    if (EmpImpQ && EmpImpQ.length > 0) {
      setValue('impQuesC', EmpImpQ);
    }
  }, [EmpImpQ, setValue]);

  useEffect(() => {
    let isMounted = true;
    const loadProfilePhoto = async () => {
      // Check if backend already sent pre-signed URL in profilePhotoUrl or profilePhoto
      const directUrl =
        currentEmp?.profilePhotoUrl ||
        (typeof currentEmp?.profilePhoto === 'string' &&
          (currentEmp.profilePhoto.startsWith('http://') ||
            currentEmp.profilePhoto.startsWith('https://') ||
            currentEmp.profilePhoto.startsWith('data:'))
          ? currentEmp.profilePhoto
          : null);

      if (directUrl) {
        if (isMounted) {
          setProfilePhotoUrl(directUrl);
          setValue('avatarUrl', directUrl);
        }
        return;
      }

      if (!currentEmp?.profilePhoto) {
        if (isMounted) setProfilePhotoUrl(null);
        return;
      }

      const photoKey = currentEmp.profilePhoto;

      if (typeof photoKey === 'string' && photoKey.startsWith('/assets/profile/')) {
        const base = axiosInstance.defaults.baseURL?.replace(/\/$/, '').replace(/\/api.*$/, '');
        const fullUrl = `${base}${photoKey}`;
        if (isMounted) {
          setProfilePhotoUrl(fullUrl);
          setValue('avatarUrl', fullUrl);
        }
        return;
      }

      // S3 key — fetch presigned URL from backend if not already appended
      try {
        const { data } = await axiosInstance.get('/rest/employee/profile-photo-url', {
          params: { key: photoKey },
          headers: { Authorization: `Bearer ${token}` },
        });
        const photoUrl = data?.url || data?.photoUrl || (typeof data === 'string' ? data : null);
        if (isMounted) {
          setProfilePhotoUrl(photoUrl);
          if (photoUrl) {
            setValue('avatarUrl', photoUrl);
          }
        }
      } catch (err) {
        console.error('Failed to load profile photo URL', err);
        if (isMounted) setProfilePhotoUrl(null);
      }
    };

    loadProfilePhoto();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmp?.profilePhoto, currentEmp?.profilePhotoUrl]);

  useEffect(() => {
    if (profilePhotoUrl) {
      setValue('avatarUrl', profilePhotoUrl);
    }
  }, [profilePhotoUrl, setValue]);

  useEffect(
    () => {
      if (currentEmp) {
        reset(defaultValues);
        if (currentEmp.presentCountrIdy) {
          handleCountryChange(currentEmp.presentCountrIdy.countriesId);
        }
        if (currentEmp.presentStateId) {
          handleStateChange(currentEmp.presentStateId.statesId);
        }
        if (currentEmp.permanentCountry) {
          handlePerCountryChange(currentEmp.permanentCountry.countriesId);
        }
        if (currentEmp.permanentStateId) {
          handlePerStateChange(currentEmp.permanentStateId.statesId);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentEmp, reset]
  );

  // Watch for changes in the employment type (empTyp)
  const watchedEmpTyp = watch('empTyp'); // Watch the `empTyp` field

  // Effect to handle visibility of empGrade when currentEmp is populated
  useEffect(() => {
    if (
      watchedEmpTyp &&
      ['Freelance', 'Full-time Employment'].includes(watchedEmpTyp.employmentTypeName)
    ) {
      // Ensure empGrade field is visible if empTyp is 'Freelance' or 'Full Time'
      setValue('empGrade', currentEmp?.empGradeId || null, { shouldValidate: true });
    }
  }, [watchedEmpTyp, currentEmp, setValue]);

  const copyCurrentAddressToPermanent = () => {
    if (!isSameAsCurrent) {
      setValue('permAddLn1', watch('curAddLn1'));
      setValue('permAddLn2', watch('curAddLn2'));
      setValue('permAddCntr', watch('curAddCntr'));
      setValue('permAddState', watch('curAddState'));
      setValue('permAddCity', watch('curAddCity'));
      setValue('permAddLandMrk', watch('curAddLandMrk'));
      setValue('permAddZip', watch('curAddZip'));
      setValue('permAddLandLn', watch('curAddLandLn'));
    } else {
      setValue('permAddLn1', '');
      setValue('permAddLn2', '');
      setValue('permAddCntr', null);
      setValue('permAddState', null);
      setValue('permAddCity', null);
      setValue('permAddLandMrk', '');
      setValue('permAddZip', '');
      setValue('permAddLandLn', '');
    }
  };
  const handleCheckboxChange = (e) => {
    setIsSameAsCurrent(!isSameAsCurrent);
    copyCurrentAddressToPermanent();
  };

  const isCurrentAndPermanentAddressSame = () => {
    const curAddLn1 = watch('curAddLn1');
    const permAddLn1 = watch('permAddLn1');

    // Check if all fields are equal
    const isEqual =
      curAddLn1 === permAddLn1 &&
      watch('curAddLn2') === watch('permAddLn2') &&
      watch('curAddCntr')?.countriesId === watch('permAddCntr')?.countriesId &&
      watch('curAddState')?.statesId === watch('permAddState')?.statesId &&
      watch('curAddCity')?.cityId === watch('permAddCity')?.cityId &&
      watch('curAddLandMrk') === watch('permAddLandMrk') &&
      watch('curAddZip') === watch('permAddZip') &&
      watch('curAddLandLn') === watch('permAddLandLn');

    // Only return true if addresses are equal AND at least one key field is filled
    return isEqual && !!curAddLn1?.trim();
  };

  // use effrct for fetching data
  useEffect(() => {
    const handleFetchedData = async () => {
      // called api - Source of hire
      await axiosInstance
        .get(`/rest/candidate/external/fetchEmpMastersData`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setSrcOfHrArr(res.data.scrOfhireData);
          setGenderArr(res.data.genderData);
          setDesgntnArr(res.data.desginationData);
          setQualArr(res.data.qualData);
          setNmTitleArr(res.data.nmTitleData);
          setCountryArr(res.data.countriesData);
          setUniversityArr(res.data.universityData);
          setQualTypeArr(res.data.qualTypData);
          setStreamArr(res.data.streamData);
          setLangArr(res.data.langData);
          setEmpTypArr(res.data.empTypData);

          // -------------------------------------------------------------
          setEmpGradeArr(res.data.empGradeData);

          // ---------------------------------------------------------------
          setRelgnArr(res.data.relgnData);
          setRelshnshipArr(res.data.relshnshipData || []);
          setUnitOfMsrArr(res.data.unitOfMsrData);
          setBloodGrpArr(res.data.bloodGrpData);
          setMaritalStArr(res.data.maritalStData);
          setVisaNmArr(res.data.visaNmData);
          setVisaTypArr(res.data.visaTypData);
          setRawCityArr(res.data.citiesData);
          setBankNmArr(res.data.bankNmData);
          setBankTypArr(res.data.bankTypData);
          setImpQueArr(res.data.impQueData);
          setCertInstNmArr(res.data.certInst);
          setCertNmArr(res.data.certNm);
        })
        .catch((err) => {
          console.error(err);
          handleApiError(err);
        });
    };
    handleFetchedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const filterPhoneCode = createFilterOptions({
    stringify: (option) => option.countryName + option.phoneCode,
  });
  const filterCandidate = createFilterOptions({
    stringify: (option) => option.firstName + option.lastName + option.email,
  });
  const filterCurrency = createFilterOptions({
    stringify: (option) => option.countryName + option.currencySymbol,
  });


  useEffect(() => {
    const defaultCountry = {
      countriesId: 101,
      countryName: 'India',
      shortName: 'IND',
      numericCode: '356',
      phoneCode: '91',
      countryCapital: 'New Delhi',
      currency: 'INR',
      currencyName: 'Indian rupee',
      currencySymbol: '₹',
      nativeName: 'भारत',
      tld: '.in',
      region: 'Asia',
      timezones:
        "[{zoneName:'Asia\\/Kolkata',gmtOffset:19800,gmtOffsetName:'UTC+05:30',abbreviation:'IST',tzName:'Indian Standard Time'}]",
      startDate: null,
      endDate: null,
    };

    const cur = subscr?.subscrSite?.subscrCountry ?? defaultCountry;

    if (cur) {
      setValue(`empExp[0].ctccurncy`, cur, { shouldValidate: true });
      setValue(`phncode`, cur.phoneCode, { shouldValidate: true });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file) {
        const isTooLarge = file.size / (1024 * 1024) > maxSizeOfDocs; // Convert to MB
        setIsFileTooLarge(isTooLarge);

        if (!isTooLarge) {
          const newFile = Object.assign(file, {
            preview: URL.createObjectURL(file),
          });

          setValue('avatarUrl', newFile, { shouldValidate: true });
          setCurEmpPic(true);
        } else {
          // Clear image if oversized
          setValue('avatarUrl', null, { shouldValidate: true });
          setCurEmpPic(false);
        }
      }
    },
    [setValue, maxSizeOfDocs]
  );

  const handleRemovePhoto = useCallback(() => {
    setIsProfilePhotoRemoved(true); // marks for deletion
    setCurEmpPic(null); // removes preview
    setValue('avatarUrl', null); // clears input value
    setIsFileTooLarge(false); // reset validation
  }, [setValue]);

  const handleCountryChange = (selectedCountryId) => {
    axiosInstance
      .get(`/rest/state/findStates?countryId=${selectedCountryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setCurStateArr(res.data);
      })
      .catch((error) => {
        setCurStateArr([]);
        handleApiError(error);
      });
  };
  const handlePerCountryChange = (selectedCountryId) => {
    axiosInstance
      .get(`/rest/state/findStates?countryId=${selectedCountryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setPerStateArr(res.data);
      })
      .catch((error) => {
        setPerStateArr([]);
        handleApiError(error);
      });
  };
  const handleStateChange = (selectedStateId) => {
    axiosInstance
      .get(`/rest/cities/findCities?stateId=${selectedStateId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setCurCityArr(res.data);
      })
      .catch((error) => {
        setCurCityArr([]);
        handleApiError(error);
      });
  };
  const handlePerStateChange = (selectedStateId) => {
    axiosInstance
      .get(`/rest/cities/findCities?stateId=${selectedStateId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setPerCityArr(res.data);
      })
      .catch((error) => {
        setPerCityArr([]);
        handleApiError(error);
      });
  };

  const populateCandidateData = useCallback(
    (data) => {
      if (!data) return;
      const cand = data.candidate || data;
      if (!cand) return;

      setSelectedCandidate(cand);
      setValue('candidate', cand, { shouldValidate: true });

      if (cand.lastUpdatedDate) {
        setLastUpdatedDateCand(new Date(cand.lastUpdatedDate));
      }
      setValue('nameTitle', cand.nameTitle || null);
      setValue('fname', cand.firstName || '');
      setValue('mname', cand.middleName || '');
      setValue('lname', cand.lastName || '');
      setValue('gender', cand.gender || null);
      setValue('email', cand.email ? decryptData(cand.email) : '');
      setValue('phncode', cand.mobPhoneCode || null);
      setValue('mobno', cand.mobileNumber ? decryptData(cand.mobileNumber) : '');
      setValue('srcofhire', cand.sourceOfHire || null);
      setValue('srcofhireNm', cand.sourceOfHireName || '');
      setValue('linkedinLink', cand.linkedinUrl || '');

      if (cand.uniqueNoType === 'AADHAR') {
        setValue('aadharno', cand.panNo ? decryptData(cand.panNo) : '');
      } else {
        setValue('panno', cand.panNo ? decryptData(cand.panNo) : '');
      }

      // Profile Photo
      if (cand.profilePhotoUrl) {
        setProfilePhotoUrl(cand.profilePhotoUrl);
        setValue('avatarUrl', cand.profilePhotoUrl);
        setCurEmpPic(true);
      } else if (cand.profilePhoto) {
        const candPhoto = cand.profilePhoto;
        if (
          candPhoto.startsWith('http://') ||
          candPhoto.startsWith('https://') ||
          candPhoto.startsWith('data:')
        ) {
          setProfilePhotoUrl(candPhoto);
          setValue('avatarUrl', candPhoto);
          setCurEmpPic(true);
        } else if (candPhoto.startsWith('/assets/')) {
          const base = axiosInstance.defaults.baseURL?.replace(/\/$/, '').replace(/\/api.*$/, '');
          const url = `${base}${candPhoto}`;
          setProfilePhotoUrl(url);
          setValue('avatarUrl', url);
          setCurEmpPic(true);
        } else {
          axiosInstance
            .get('/rest/employee/profile-photo-url', {
              params: { key: candPhoto },
              headers: { Authorization: `Bearer ${token}` },
            })
            .then(({ data: resData }) => {
              const photoUrl =
                resData?.url || resData?.photoUrl || (typeof resData === 'string' ? resData : null);
              if (photoUrl) {
                setProfilePhotoUrl(photoUrl);
                setValue('avatarUrl', photoUrl);
                setCurEmpPic(true);
              }
            })
            .catch((err) => console.error('Failed to fetch candidate profile photo URL:', err));
        }
      }

      // Address
      if (cand.currentLocationCity) {
        const city = cand.currentLocationCity;
        const state = cand.currentLocationCity.stateId;
        const country = cand.currentLocationCity.stateId?.countryId;

        if (country) {
          setValue('curAddCntr', country);
          handleCountryChange(country.countriesId);
        }
        if (state) {
          setValue('curAddState', state);
          handleStateChange(state.statesId);
        }
        if (city) {
          setValue('curAddCity', city);
        }
      }

      // Education
      if (data.educationDetails && Array.isArray(data.educationDetails) && data.educationDetails.length > 0) {
        const e = data.educationDetails.map((cEdu) => ({
          eduSrno: 0,
          university: cEdu.university || null,
          othrUni: cEdu.universityName || '',
          qualtype: cEdu.qualificationType || cEdu.qualification || null,
          qualification: cEdu.qualification || null,
          stream: cEdu.stream || null,
          candpercnt: cEdu.candidateQualPercentage || 0.0,
          currentypurs: cEdu.currentlyPursuing || false,
          candcgpa: cEdu.candidateQualCgpa || 0.0,
          edufromDate: cEdu.candidateQualFromDate ? new Date(cEdu.candidateQualFromDate) : null,
          edutoDate: cEdu.candidateQualToDate ? new Date(cEdu.candidateQualToDate) : null,
          fromCandidate: true,
        }));
        setEmpEdu(e);
        setValue('empEdu', e);
      }

      // Certifications
      if (data.certifications && Array.isArray(data.certifications) && data.certifications.length > 0) {
        const e = data.certifications.map((eCert) => ({
          cerSrno: 0,
          certiNm: eCert.certificationName || '',
          certiInstiNm: eCert.instituteName || '',
          certfromDate: eCert.durationFrom ? new Date(eCert.durationFrom) : null,
          certtoDate: eCert.durationTo ? new Date(eCert.durationTo) : null,
          fromCandidate: true,
        }));
        setEmpCert(e);
        setValue('empCert', e);
      }

      // Experience
      if (data.expDetails && Array.isArray(data.expDetails) && data.expDetails.length > 0) {
        const e = data.expDetails.map((eExp) => ({
          expSrno: 0,
          compNm: eExp.candidateExperienceCompanyName || '',
          designation: eExp.candidateDesignation || null,
          ctc: eExp.candidateCtc ? decryptData(eExp.candidateCtc) : 0,
          ctccurncy: eExp.candidateCtcCurrency || null,
          country: eExp.candidateExperienceCountryid || null,
          currentywrkng: eExp.candidateCurrentlyWorking || false,
          expfromDate: eExp.candidateExperienceFromDate
            ? new Date(eExp.candidateExperienceFromDate)
            : null,
          exptoDate: eExp.candidateExperienceToDate
            ? new Date(eExp.candidateExperienceToDate)
            : null,
          fromCandidate: true,
        }));
        setEmpExp(e);
        setValue('empExp', e);
        setSwitchState((prevState) => ({
          ...prevState,
          experience: true,
        }));
      }

      // References
      if (data.refDetails && Array.isArray(data.refDetails) && data.refDetails.length > 0) {
        const e = data.refDetails.map((eRef) => ({
          refSrno: 0,
          refNm: eRef.candidateReferenceName ? decryptData(eRef.candidateReferenceName) : '',
          refOrgNm: eRef.candidateReferenceOrganizationName
            ? decryptData(eRef.candidateReferenceOrganizationName)
            : '',
          refdesig: eRef.candidateReferenceDesignation || null,
          refEmail: eRef.candidateReferenceEmail ? decryptData(eRef.candidateReferenceEmail) : '',
          refContact: eRef.candidateReferenceContactNumber
            ? decryptData(eRef.candidateReferenceContactNumber)
            : '',
          fromCandidate: true,
        }));
        setEmpRef(e);
        setValue('empRef', e);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setValue, token]
  );

  const effectiveCandidateId = candidateId || id || routeParams?.id;

  useEffect(() => {
    if (candidateData) {
      populateCandidateData(candidateData);
    } else if (effectiveCandidateId && !currentEmp && isOnEmployeeForm) {
      axiosInstance
        .get(`/rest/candidate/external/singleCandDetails/${effectiveCandidateId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          populateCandidateData(res.data);
        })
        .catch((err) => {
          console.error('Error fetching candidate details:', err);
        });
    }
  }, [candidateData, effectiveCandidateId, currentEmp, isOnEmployeeForm, populateCandidateData, token]);

  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };


  const onSubmit = handleSubmit(async (data) => {
    loadingSend.onTrue();


    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      loadingSend.onFalse();

      const empData = {
        employeeTypeId: data.empTyp,
        empGradeId: data.empGrade,
        isFinalStep: data.isFinalStep || isFinalStep,
        employeeCode: data.empCode,
        dateOfJoining: data.dateOfJoin,
        designationId: data.designation,
        titleId: data.nameTitle,
        firstName: data.fname,
        middleName: data.mname,
        lastName: data.lname,
        email: encryptData(data.email),
        mobPhoneCode: data.phncode,
        mobileNumber: encryptData(data.mobno),
        dateOfBirth: data.dateOfBirth,
        placeOfBirth: data.placeOfBirth,
        genderId: data.gender,
        weight: data.weight,
        linkedinLink: data.linkedinLink,
        unitOfMeasureWeightId: data.unitOfWeight,
        unitOfMeasureHeightId: data.unitOfHeight,
        ofclEmail: encryptData(data.ofclEmail),
        height: data.height,
        bloodGroupId: data.bloodGrp,
        maritalStatusId: data.maritalStatus,
        internationalWorker: data.isInternationalWrkr,
        director: data.isdirector,
        nationality: data.nationality,
        religionId: data.religion,
        presentAddress1: data.curAddLn1,
        presentAddress2: data.curAddLn2,
        presentLandmark: data.curAddLandMrk,
        presentCityId: data.curAddCity,
        presentStateId: data.curAddState,
        presentCountrIdy: data.curAddCntr,
        presentZipcode: data.curAddZip,
        presentLandline: data.curAddLandLn,
        permanentLandline: data.permAddLandLn,
        permanentZipcode: data.permAddZip,
        permanentCountry: data.permAddCntr,
        permanentStateId: data.permAddState,
        permanentCityId: data.permAddCity,
        permanentLandmark: data.permAddLandMrk,
        permanentAddress2: data.permAddLn2,
        permanentAddress1: data.permAddLn1,
        pan: encryptData(data.panno),
        aadharNumber: encryptData(data.aadharno),
        pran: encryptData(data.pranno),
        uan: encryptData(data.pfno),
        sourceOfHireId: data.srcofhire,
        sourceOfHireDetails: data.srcofhireNm,
        startDate: data.startDate,
        profilePhoto: isProfilePhotoRemoved ? null : (currentEmp?.profilePhoto || null),
      };
      const formData = new FormData();
      formData.append('empD', JSON.stringify(empData));
      formData.append('profileP', data.avatarUrl);
      if (currentEmp) {
        formData.append('empId', currentEmp.employeeId);
        const updtEmpUrl = `/rest/employee/external/updtEmp`;
        axiosInstance
          .put(updtEmpUrl, formData, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            const empCode = res.data.employeeCode;
            if (empCode) {
              enqueueSnackbar('Employee Updated successfully!', { variant: 'success' });
            } else {
              enqueueSnackbar('Draft Saved successfully!', { variant: 'success' });
            }
          })
          .catch((error) => {
            if (error.response?.data?.message) {
              enqueueSnackbar(error.response.data.message, { variant: 'error' });
            } else {
              enqueueSnackbar('Something went wrong', { variant: 'error' });
            }
            // prevent further throwing
            return null;
          });

        if (isProfilePhotoRemoved && !curEmpPic) {

          await axiosInstance.delete(`/rest/employee/external/deleteProfile/${currentEmp?.publicId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        }

        if (activeStep === 3 || activeStep <= 7) {
          if (currentEmpEdu || data.empEdu) {
            const addedEdus = data.empEdu.filter((edu) => edu.eduSrno === 0);
            const updtEdus = data.empEdu.filter((edu) => edu.eduSrno !== 0);
            const removeEdus = EmpEdu.filter(
              (currEdu) =>
                currEdu.eduSrno &&
                !data.empEdu.some((edu) => edu.eduSrno === currEdu.eduSrno)
            );
            if (addedEdus.length > 0) {
              addedEdus.forEach((cEdu) => {
                const cEduData = {
                  empId: {
                    employeeId: currentEmp.employeeId
                  },
                  university: cEdu.university,
                  universityName: cEdu.othrUni,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  percentage: cEdu.candpercnt,
                  cgpa: cEdu.candcgpa,
                  currentlyPursuing: cEdu.currentypurs,
                  durationFrom: cEdu.edufromDate,
                  durationTo: cEdu.edutoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const addCandEduUrl = `/rest/employee/external/empDetails/addEmpEdu`;
                axiosInstance
                  .post(addCandEduUrl, cEduData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res4) => { });
              });
            }
            if (updtEdus.length > 0) {
              updtEdus.forEach(async (cEdu) => {
                const cEduData = {
                  university: cEdu.university,
                  universityName: cEdu.othrUni,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  percentage: cEdu.candpercnt,
                  cgpa: cEdu.candcgpa,
                  currentlyPursuing: cEdu.currentypurs,
                  durationFrom: cEdu.edufromDate,
                  durationTo: cEdu.edutoDate,
                };
                const addCandEduUrl = `rest/employee/external/empDetails/updateEduData/${cEdu?.eduSrno}`;
                axiosInstance
                  .put(addCandEduUrl, cEduData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res4) => { });
              });
            }
            if (removeEdus.length > 0) {
              removeEdus.forEach(async (remove) => {
                if (remove?.eduSrno !== 0) {

                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteEduData/${remove?.eduSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 5 || activeStep <= 7) {
          if (currentEmpExp || data.empExp) {
            const addedExp = data.empExp.filter((edu) => edu.expSrno === 0);
            const updtExp = data.empExp.filter((edu) => edu.expSrno !== 0);
            const removeExp = EmpExp.filter(
              (currExp) =>
                !data.empExp.some((edu) => edu.expSrno === currExp.expSrno)
            );
            if (addedExp.length > 0) {
              addedExp.forEach((cExp) => {
                const cExpData = {
                  employeeId: {
                    employeeId: currentEmp.employeeId
                  },
                  company: cExp.compNm,
                  designation: cExp.designation,
                  ctcCurrency: cExp.ctccurncy,
                  ctc: encryptData(cExp.ctc),
                  durationFrom: cExp.expfromDate,
                  durationTo: cExp.exptoDate,
                  currentlyWorking: cExp.currentywrkng,
                  country: cExp.country,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candExpUrl = `/rest/employee/external/empDetails/addEmpExp`;
                axiosInstance
                  .post(candExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res5) => { });
              });
            }
            if (updtExp.length > 0) {
              updtExp.forEach(async (cExp) => {
                const cExpData = {
                  company: cExp.compNm,
                  designation: cExp.designation,
                  ctcCurrency: cExp?.currencySymbol,
                  country: cExp.country,
                  ctc: encryptData(cExp.ctc),
                  durationFrom: cExp.expfromDate,
                  durationTo: cExp.exptoDate,
                  currentlyWorking: cExp.currentywrkng,
                  lastUpdatedDate: new Date()
                };

                const addCandExpUrl = `rest/employee/external/empDetails/updateExpData/${cExp?.expSrno}`;
                axiosInstance
                  .put(addCandExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res6) => { });
              });
            }
            if (removeExp.length > 0) {
              removeExp.forEach(async (remove) => {
                if (remove?.expSrno !== 0) {
                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteExpData/${remove?.expSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 3 || activeStep <= 7) {
          if (currentEmpCert || data.empCert) {
            const addedCert = data.empCert.filter((edu) => edu.cerSrno === 0);
            const updtCert = data.empCert.filter((edu) => edu.cerSrno !== 0);
            const removeCert = EmpCert.filter(
              (currEdu) => !updtCert.some((edu) => edu.cerSrno === currEdu.cerSrno)
            );
            if (addedCert.length > 0) {
              addedCert.forEach((cCert) => {
                const cCertData = {
                  employeeId: {
                    employeeId: currentEmp?.employeeId
                  },
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candCertUrl = `/rest/employee/external/empDetails/addEmpCert`;
                axiosInstance
                  .post(candCertUrl, cCertData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtCert.length > 0) {
              updtCert.forEach(async (cCert) => {
                const cCertData = {
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,

                  lastUpdatedDate: new Date(),
                };

                const updtCandCertUrl = `rest/employee/external/empDetails/updateCertData/${cCert?.cerSrno}`;
                axiosInstance
                  .put(updtCandCertUrl, cCertData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeCert.length > 0) {
              removeCert.forEach(async (remove) => {
                if (remove?.srno !== 0) {
                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteCertData/${remove?.cerSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 5 || activeStep <= 7) {
          if (currentEmpRef || data.empRef) {
            const addedRef = data.empRef.filter((edu) => edu.refSrno === 0);
            const updtRef = data.empRef.filter((edu) => edu.refSrno !== 0);
            const removeRef = EmpRef.filter(
              (currEdu) => !updtRef.some((edu) => edu.refSrno === currEdu.refSrno)
            );
            if (addedRef.length > 0) {
              addedRef.forEach((cRef) => {
                const cRefData = {
                  employeeId: {
                    employeeId: currentEmp.employeeId
                  },
                  empReferenceName: cRef.refNm,
                  empReferenceOrganization: cRef.refOrgNm,
                  designationId: cRef.refdesig,
                  empReferenceEmail: encryptData(cRef.refEmail),
                  empReferenceContactNumber: encryptData(cRef.refContact),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candRefUrl = `/rest/employee/external/empDetails/addEmpRef`;
                axiosInstance
                  .post(candRefUrl, cRefData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtRef.length > 0) {
              updtRef.forEach(async (cRef) => {
                const cRefData = {
                  empReferenceName: cRef.refNm,
                  empReferenceOrganization: cRef.refOrgNm,
                  designationId: cRef.refdesig,
                  empReferenceEmail: encryptData(cRef.refEmail),
                  empReferenceContactNumber: encryptData(cRef.refContact),

                  lastUpdatedDate: new Date(),
                };
                const updtCandRefUrl = `rest/employee/external/empDetails/updateRefData/${cRef?.refSrno}`;
                axiosInstance
                  .put(updtCandRefUrl, cRefData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeRef.length > 0) {
              removeRef.forEach(async (remove) => {
                if (remove?.srno !== 0) {

                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteRefData/${remove?.refSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 3 || activeStep <= 7) {
          if (currentEmpLang || data.empLang) {
            const addedLang = data.empLang.filter((edu) => edu.langSrno === 0);
            const updtLang = data.empLang.filter((edu) => edu.langSrno !== 0);
            const removeLang = EmpLang.filter(
              (currEdu) => !updtLang.some((edu) => edu.langSrno === currEdu.langSrno)
            );
            if (addedLang.length > 0) {
              addedLang.forEach((eLang) => {
                const eLangKnwn = {
                  employee: {
                    employeeId: currentEmp.employeeId
                  },
                  language: eLang.lang,
                  read: eLang.read,
                  write: eLang.write,
                  speak: eLang.speak,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eLangUrl = `/rest/employee/external/empDetails/addEmpLang`;
                axiosInstance
                  .post(eLangUrl, eLangKnwn, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtLang.length > 0) {
              updtLang.forEach(async (eLang) => {
                const eLangKnwn = {
                  language: eLang.lang,
                  read: eLang.read,
                  write: eLang.write,
                  speak: eLang.speak,

                  lastUpdatedDate: new Date(),
                };


                const updtLangKnwnUrl = `/rest/employee/external/empDetails/updateLangData/${eLang?.langSrno}`;
                axiosInstance
                  .put(updtLangKnwnUrl, eLangKnwn, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeLang.length > 0) {
              removeLang.forEach(async (remove) => {
                if (remove?.srno !== 0) {


                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteLangData/${remove?.langSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 6 || activeStep <= 7) {
          if (currentEmpBank || data.empBank) {
            const addedBank = data.empBank.filter((edu) => edu.bankSrno === 0);
            const updtBank = data.empBank.filter((edu) => edu.bankSrno !== 0);
            const removeBank = EmpBank.filter(
              (currEdu) => !updtBank.some((edu) => edu.bankSrno === currEdu.bankSrno)
            );
            if (addedBank.length > 0) {
              addedBank.forEach((eBank) => {
                const empBankD = {
                  employee: {
                    employeeId: currentEmp.employeeId
                  },
                  bankName: eBank.bankNm,
                  branch: eBank.branch,
                  accountName: eBank.accNm,
                  accountType: eBank.accTyp,
                  accountNumber: encryptData(eBank.accNo),
                  ifsc: encryptData(eBank.ifsc),
                  swiftCode: encryptData(eBank.swiftCd),
                  startDate: eBank.startDate,
                  endDate: eBank.endDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eBankUrl = `/rest/employee/external/empDetails/addEmpBank`;
                axiosInstance
                  .post(eBankUrl, empBankD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtBank.length > 0) {
              updtBank.forEach(async (eBank) => {
                const empBankD = {
                  bankName: eBank.bankNm,
                  branch: eBank.branch,
                  accountName: eBank.accNm,
                  accountType: eBank.accTyp,
                  accountNumber: encryptData(eBank.accNo),
                  ifsc: encryptData(eBank.ifsc),
                  swiftCode: encryptData(eBank.swiftCd),
                  startDate: eBank.startDate,
                  endDate: eBank.endDate,

                  lastUpdatedDate: new Date(),
                };
                const updtBankUrl = `/rest/employee/external/empDetails/updateBankData/${eBank?.bankSrno}`;

                axiosInstance
                  .put(updtBankUrl, empBankD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeBank.length > 0) {
              removeBank.forEach(async (remove) => {
                axiosInstance.delete(`/rest/employee/external/empDetails/deleteBankData/${remove?.bankSrno}`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              });
            }
          }
        }
        if (activeStep === 4 || activeStep <= 7) {
          if (currentEmpVisa || data.empVisa) {
            const addedVisa = data.empVisa.filter((edu) => edu.visaSrno === 0);
            const updtVisa = data.empVisa.filter((edu) => edu.visaSrno !== 0);
            const removeVisa = EmpVisa.filter(
              (currEdu) => !updtVisa.some((edu) => edu.visaSrno === currEdu.visaSrno)
            );
            if (addedVisa.length > 0) {
              addedVisa.forEach((eVisa) => {
                const empVisaD = {
                  employee: {
                    employeeId: currentEmp.employeeId
                  },
                  visaNumber: encryptData(eVisa.visaNo),
                  visaNameId: eVisa.visaNm,
                  visaTypeId: eVisa.visaTyp,
                  placeOfIssue: eVisa.placeOfissue,
                  dateOfIssue: eVisa.issueDt,
                  dateOfExpiry: eVisa.expiryDt,
                  visaForCountry: eVisa.forCntry,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eVisaUrl = `/rest/employee/external/empDetails/addEmpVisa`;
                axiosInstance
                  .post(eVisaUrl, empVisaD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtVisa.length > 0) {
              updtVisa.forEach(async (eVisa) => {
                const empVisaD = {
                  visaNumber: encryptData(eVisa.visaNo),
                  visaNameId: eVisa.visaNm,
                  visaTypeId: eVisa.visaTyp,
                  placeOfIssue: eVisa.placeOfissue,
                  dateOfIssue: eVisa.issueDt,
                  dateOfExpiry: eVisa.expiryDt,
                  visaForCountry: eVisa.forCntry,

                  lastUpdatedDate: new Date(),
                };


                const updtVisaUrl = `/rest/employee/external/empDetails/updateVisaData/${eVisa?.visaSrno}`;

                axiosInstance
                  .put(updtVisaUrl, empVisaD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeVisa.length > 0) {
              removeVisa.forEach(async (remove) => {
                if (remove?.visaSrno) {

                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteVisaData/${remove?.visaSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 7) {
          if (currentEmpWrk || data.empRelWrkn) {
            const addedWrk = data.empRelWrkn.filter((edu) => edu.cntctSrno === 0);
            const updtWrk = data.empRelWrkn.filter((edu) => edu.cntctSrno !== 0);
            const removeWrk = EmpWrk.filter(
              (currEdu) => !updtWrk.some((edu) => edu.cntctSrno === currEdu.cntctSrno)
            );
            if (addedWrk.length > 0) {
              addedWrk.forEach((eRelwrk) => {
                const empRelWrkD = {
                  employeeId: {
                    employeeId
                  },
                  relEmpName: eRelwrk.name,
                  citiesId: eRelwrk.curAddCity,
                  countryId: eRelwrk.curAddCntr,
                  stateId: eRelwrk.curAddState,
                  designationId: eRelwrk.refdesig,
                  relationshipId: eRelwrk.relationship,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eWrkRelUrl = `/rest/employee/external/empDetails/addEmpRelWrk`;
                axiosInstance
                  .post(eWrkRelUrl, empRelWrkD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtWrk.length > 0) {
              updtWrk.forEach(async (eRelwrk) => {
                const empRelWrkD = {
                  relEmpName: eRelwrk.name,
                  citiesId: eRelwrk.curAddCity,
                  countryId: eRelwrk.curAddCntr,
                  stateId: eRelwrk.curAddState,
                  designationId: eRelwrk.refdesig,
                  relationshipId: eRelwrk.relationship,

                  lastUpdatedDate: new Date(),
                };

                const updtRelWrkUrl = `rest/employee/external/empDetails/updateWrkData/${eRelwrk?.cntctSrno}`;
                axiosInstance
                  .put(updtRelWrkUrl, empRelWrkD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeWrk.length > 0) {
              removeWrk.forEach(async (remove) => {
                if (remove?.srno) {


                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteWrkData/${remove?.cntctSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 1 || activeStep <= 7) {
          if (currentEmpFam || data.empFamilyRel) {
            const addedFam = data.empFamilyRel.filter((edu) => edu.relSrno === 0);
            const updtFam = data.empFamilyRel.filter((edu) => edu.relSrno !== 0);
            const removeFam = EmpFam.filter(
              (currEdu) => !updtFam.some((edu) => edu.relSrno === currEdu.relSrno)
            );
            if (addedFam.length > 0) {
              addedFam.forEach((eFam) => {
                const eFamRel = {
                  employee: {
                    employeeId: currentEmp.employeeId
                  },
                  relativeName: eFam.name,
                  relationship: eFam.relationship,
                  dateOfBirth: eFam.dob,
                  alive: eFam.isAlive,
                  passportNumber: encryptData(eFam.passNo),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eFamUrl = `/rest/employee/external/empDetails/addEmpFam`;
                axiosInstance
                  .post(eFamUrl, eFamRel, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtFam.length > 0) {
              updtFam.forEach(async (eFam) => {
                const eFamRel = {
                  relativeName: eFam.name,
                  relationship: eFam.relationship,
                  dateOfBirth: eFam.dob,
                  alive: eFam.isAlive,
                  passportNumber: encryptData(eFam.passNo),

                  lastUpdatedDate: new Date(),
                };


                const updtFamUrl = `rest/employee/external/empDetails/updateFamData/${eFam?.relSrno}`;
                axiosInstance
                  .put(updtFamUrl, eFamRel, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeFam.length > 0) {
              removeFam.forEach(async (remove) => {
                if (remove?.srno) {

                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteFamData/${remove?.relSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 4 || activeStep <= 7) {
          if (currentEmpPass || data.empPassport) {
            const addedPass = data.empPassport.filter((edu) => edu.passSrno === 0);
            const updtPass = data.empPassport.filter((edu) => edu.passSrno !== 0);
            const removePass = EmpPass.filter(
              (currEdu) => !updtPass.some((edu) => edu.passSrno === currEdu.passSrno)
            );
            if (addedPass.length > 0) {
              addedPass.forEach((passPrt) => {
                const passPrtD = {
                  employee: {
                    employeeId: currentEmp.employeeId
                  },
                  passportNumber: encryptData(passPrt.passNo),
                  ecnrstampedName: passPrt.ecnrStamp,
                  placeOfIssue: passPrt.issuePlace,
                  dateOfIssue: passPrt.issueDt,
                  dateOfExpiry: passPrt.expiryDt,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/employee/external/empDetails/addPassport`;
                axiosInstance
                  .post(addPassprtUrl, passPrtD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res1) => { });
              });
            }
            if (updtPass.length > 0) {
              updtPass.forEach(async (passPrt) => {
                const passPrtD = {
                  passportNumber: encryptData(passPrt.passNo),
                  ecnrstampedName: passPrt.ecnrStamp,
                  placeOfIssue: passPrt.issuePlace,
                  dateOfIssue: passPrt.issueDt,
                  dateOfExpiry: passPrt.expiryDt,

                  startDate: data.startDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };


                const updtPassUrl = `rest/employee/external/empDetails/updatePassData/${passPrt?.passSrno}`;
                axiosInstance
                  .put(updtPassUrl, passPrtD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removePass.length > 0) {
              removePass.forEach(async (remove) => {

                axiosInstance.delete(`/rest/employee/external/empDetails/deletePassData/${remove?.passSrno}`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              });
            }
          }
        }
        if (activeStep === 2 || activeStep <= 7) {
          if (currentEmpEmrg || data.empEmrgncyContact) {
            const addedEmrgs = data.empEmrgncyContact.filter((edu) => edu.cntctSrno === 0);
            const updtEmrgs = data.empEmrgncyContact.filter((edu) => edu.cntctSrno !== 0);
            const removeEmrgs = EmpEmrg.filter(
              (currEmrg) => !updtEmrgs.some((edu) => edu.cntctSrno === currEmrg.cntctSrno)
            );
            if (addedEmrgs.length > 0) {
              addedEmrgs.forEach((emrgContct) => {
                const emrgContctD = {
                  employee: {
                    employeeId: currentEmp.employeeId
                  },
                  fullName: emrgContct.name,
                  email: encryptData(emrgContct.email),
                  mobileNumber: encryptData(emrgContct.mobno),
                  relationId: emrgContct.relationship,
                  address1: emrgContct.curAddLn1,
                  address2: emrgContct.curAddLn2,
                  landmark: emrgContct.curAddLandMrk,
                  citiesId: emrgContct.curAddCity,
                  stateId: emrgContct.curAddState,
                  countriesId: emrgContct.curAddCntr,
                  zipcode: emrgContct.curAddZip,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/employee/external/empDetails/addEmrgncy`;
                axiosInstance
                  .post(addPassprtUrl, emrgContctD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res1) => { });
              });
            }
            if (updtEmrgs.length > 0) {
              updtEmrgs.forEach(async (emrgContct) => {
                const emrgContctD = {
                  fullName: emrgContct.name,
                  email: encryptData(emrgContct.email),
                  mobileNumber: encryptData(emrgContct.mobno),
                  relationId: emrgContct.relationship,
                  address1: emrgContct.curAddLn1,
                  address2: emrgContct.curAddLn2,
                  landmark: emrgContct.curAddLandMrk,
                  citiesId: emrgContct.curAddCity,
                  stateId: emrgContct.curAddState,
                  countriesId: emrgContct.curAddCntr,
                  zipcode: emrgContct.curAddZip,

                  startDate: data.startDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };


                const updtContUrl = `rest/employee/external/empDetails/updateEmrgData/${emrgContct?.cntctSrno}`;
                axiosInstance
                  .put(updtContUrl, emrgContctD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeEmrgs.length > 0) {
              removeEmrgs.forEach(async (remove) => {
                if (remove?.srno) {

                  axiosInstance.delete(`/rest/employee/external/empDetails/deleteEmrgData/${remove?.cntctSrno}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (currentEmpImpQ || data.impQuesC) {
          data.impQuesC.forEach(async (eImpQ) => {
            const qId = typeof eImpQ.impQue === 'object'
              ? (eImpQ.impQue?.id || eImpQ.impQue?.masterId || eImpQ.impQue?.impQueId || (eImpQ.impQue?.questionId && (eImpQ.impQue.questionId.id || eImpQ.impQue.questionId.masterId)))
              : eImpQ.impQue;

            const answerVal = typeof eImpQ.ans === 'object'
              ? (eImpQ.ans?.value || eImpQ.ans?.label || '')
              : (eImpQ.ans || '');

            if (eImpQ?.iqSrno && eImpQ.iqSrno !== 0) {
              const empImpQD = {
                questionId: {
                  id: Number(qId),
                },
                answer: answerVal,
                ansDetails: eImpQ.ansComment,
              };

              const eImpQUrl = `/rest/employee/external/empDetails/updateImpQData/${eImpQ?.iqSrno}`;
              axiosInstance
                .put(eImpQUrl, empImpQD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res9) => { });
            } else {
              const empImpQD = {
                employeeId: {
                  employeeId: currentEmp.employeeId,
                },
                questionId: {
                  id: Number(qId),
                },
                answer: answerVal,
                ansDetails: eImpQ.ansComment,
              };
              const eImpQUrl = `/rest/employee/external/empDetails/addEmpImpQue`;
              axiosInstance
                .post(eImpQUrl, empImpQD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res9) => { });
            }
          });
        }
        setSavedEmployeeId(currentEmp.employeeId);
        if (activeStep === steps.length - 1) {
          setOpenDialog(true); // Only open if it's really final step
        }
      } else {
        formData.append("candidateId", data.candidate.candidateId);
        const addEmpUrl = `/rest/employee/external/addEmp`;

        await axiosInstance
          .post(addEmpUrl, formData, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then(async (res) => {
            const promises = [];

            const generatedEmployeeID = await fetchEncryptedToken(
              res.data.employee.employeeId,
              token
            );


            setCurEmpCode(res.data.employee.employeeCode);

            const waitForEmployeeId = async (getIdFn, timeout = 5000, interval = 100) => {
              const start = Date.now();
              return new Promise((resolve, reject) => {
                const check = () => {
                  const id = getIdFn();
                  if (id) return resolve(id);
                  // eslint-disable-next-line prefer-promise-reject-errors
                  if (Date.now() - start > timeout) return reject('Employee ID not available in time');
                  setTimeout(check, interval);
                };
                check();
              });
            };

            data.empPassport.forEach(async (passPrt) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const passPrtD = {
                  employee: {
                    employeeId
                  },
                  passportNumber: encryptData(passPrt.passNo),
                  ecnrstampedName: passPrt.ecnrStamp,
                  placeOfIssue: passPrt.issuePlace,
                  dateOfIssue: passPrt.issueDt,
                  dateOfExpiry: passPrt.expiryDt,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/employee/external/empDetails/addPassport`;
                axiosInstance
                  .post(addPassprtUrl, passPrtD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping passport API, employeeId not available', err);
              }
            });

            data.empEmrgncyContact.forEach(async (emrgContct) => {

              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const emrgContctD = {
                  employee: {
                    employeeId
                  },
                  fullName: emrgContct.name,
                  email: encryptData(emrgContct.email),
                  mobileNumber: encryptData(emrgContct.mobno),
                  relationId: emrgContct.relationship,
                  address1: emrgContct.curAddLn1,
                  address2: emrgContct.curAddLn2,
                  landmark: emrgContct.curAddLandMrk,
                  citiesId: emrgContct.curAddCity,
                  stateId: emrgContct.curAddState,
                  countriesId: emrgContct.curAddCntr,
                  zipcode: emrgContct.curAddZip,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/empDetails/addEmrgncy`;
                axiosInstance
                  .post(addPassprtUrl, emrgContctD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping emergency contact API, employeeId not available', err);
              }
            });

            data.empEdu.forEach(async (cEdu) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const cEduData = {
                  empId: {
                    employeeId
                  },
                  university: cEdu.university,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  percentage: cEdu.candpercnt,
                  cgpa: cEdu.candcgpa,
                  durationFrom: cEdu.edufromDate,
                  durationTo: cEdu.edutoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const addCandEduUrl = `/rest/employee/external/empDetails/addEmpEdu`;
                axiosInstance
                  .post(addCandEduUrl, cEduData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping education API, employeeId not available', err);
              }
            });

            data.empExp.forEach(async (cExp) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const cExpData = {
                  employeeId: {
                    employeeId
                  },
                  company: cExp.compNm,
                  designation: cExp.designation,
                  ctcCurrency: cExp.ctccurncy,
                  ctc: encryptData(cExp.ctc),
                  durationFrom: cExp.expfromDate,
                  durationTo: cExp.exptoDate,
                  country: cExp.country,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candExpUrl = `/rest/employee/external/empDetails/addEmpExp`;
                axiosInstance
                  .post(candExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping experience API, employeeId not available', err);
              }
            });

            data.empCert.forEach(async (cCert) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const cCertData = {
                  employeeId: {
                    employeeId
                  },
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candCertUrl = `/rest/employee/external/empDetails/addEmpCert`;
                axiosInstance
                  .post(candCertUrl, cCertData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping certification API, employeeId not available', err);
              }
            });

            data.empRef.forEach(async (cRef) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const cRefData = {
                  employeeId: {
                    employeeId
                  },
                  empReferenceName: cRef.refNm,
                  empReferenceOrganization: cRef.refOrgNm,
                  designationId: cRef.refdesig,
                  empReferenceEmail: encryptData(cRef.refEmail),
                  empReferenceContactNumber: encryptData(cRef.refContact),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candRefUrl = `/rest/employee/external/empDetails/addEmpRef`;
                axiosInstance
                  .post(candRefUrl, cRefData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping reference API, employeeId not available', err);
              }
            });

            data.empFamilyRel.forEach(async (eFam) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const eFamRel = {
                  employee: {
                    employeeId
                  },
                  relativeName: eFam.name,
                  relationship: eFam.relationship,
                  dateOfBirth: eFam.dob,
                  alive: eFam.isAlive,
                  passportNumber: encryptData(eFam.passNo),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eFamUrl = `/rest/employee/external/empDetails/addEmpFam`;
                axiosInstance
                  .post(eFamUrl, eFamRel, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping family relative API, employeeId not available', err);
              }
            });

            data.empLang.forEach(async (eLang) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const eLangKnwn = {
                  employee: {
                    employeeId
                  },
                  language: eLang.lang,
                  read: eLang.read,
                  write: eLang.write,
                  speak: eLang.speak,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eLangUrl = `/rest/employee/external/empDetails/addEmpLang`;
                axiosInstance
                  .post(eLangUrl, eLangKnwn, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping language API, employeeId not available', err);
              }
            });

            data.empVisa.forEach(async (eVisa) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const empVisaD = {
                  employee: {
                    employeeId
                  },
                  visaNumber: encryptData(eVisa.visaNo),
                  visaNameId: eVisa.visaNm,
                  visaTypeId: eVisa.visaTyp,
                  placeOfIssue: eVisa.placeOfissue,
                  dateOfIssue: eVisa.issueDt,
                  dateOfExpiry: eVisa.expiryDt,
                  visaForCountry: eVisa.forCntry,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eVisaUrl = `/rest/employee/external/empDetails/addEmpVisa`;
                axiosInstance
                  .post(eVisaUrl, empVisaD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping Visa API, employeeId not available', err);
              }
            });

            data.empBank.forEach(async (eBank) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const empBankD = {
                  employee: {
                    employeeId
                  },
                  bankName: eBank.bankNm,
                  branch: eBank.branch,
                  accountName: eBank.accNm,
                  accountType: eBank.accTyp,
                  accountNumber: encryptData(eBank.accNo),
                  ifsc: encryptData(eBank.ifsc),
                  swiftCode: encryptData(eBank.swiftCd),
                  startDate: eBank.startDate,
                  endDate: eBank.endDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eBankUrl = `/rest/employee/external/empDetails/addEmpBank`;
                axiosInstance
                  .post(eBankUrl, empBankD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping Bank API, employeeId not available', err);
              }
            });

            data.empRelWrkn.forEach(async (eRelwrk) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const empRelWrkD = {
                  employeeId: {
                    employeeId
                  },
                  relEmpName: eRelwrk.name,
                  citiesId: eRelwrk.curAddCity,
                  countryId: eRelwrk.curAddCntr,
                  stateId: eRelwrk.curAddState,
                  designationId: eRelwrk.refdesig,
                  relationshipId: eRelwrk.relationship,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eWrkRelUrl = `/rest/employee/external/empDetails/addEmpRelWrk`;
                axiosInstance
                  .post(eWrkRelUrl, empRelWrkD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping Work Relationship API, employeeId not available', err);
              }
            });

            data.impQuesC.forEach(async (eImpQ) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const qId = typeof eImpQ.impQue === 'object'
                  ? (eImpQ.impQue?.id || eImpQ.impQue?.masterId || eImpQ.impQue?.impQueId || (eImpQ.impQue?.questionId && (eImpQ.impQue.questionId.id || eImpQ.impQue.questionId.masterId)))
                  : eImpQ.impQue;

                const answerVal = typeof eImpQ.ans === 'object'
                  ? (eImpQ.ans?.value || eImpQ.ans?.label || '')
                  : (eImpQ.ans || '');

                const empImpQD = {
                  employeeId: {
                    employeeId,
                  },
                  questionId: {
                    id: Number(qId),
                  },
                  answer: answerVal,
                  ansDetails: eImpQ.ansComment,
                };
                const eImpQUrl = `/rest/employee/external/empDetails/addEmpImpQue`;
                axiosInstance
                  .post(eImpQUrl, empImpQD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
              } catch (err) {
                console.error('Skipping Important Questions API, employeeId not available', err);
              }
            });

            setValue('empCode', res.data.employee.employeeCode);
            // Wait for all operations to complete
            await Promise.all(promises);
            router.push(paths.dashboard.humanResources.EditEmployee(generatedEmployeeID));
          });
      }
      if (activeStep === steps.length - 1 && !currentEmp) {
        if (isOnEmployeeForm) {
          enqueueSnackbar('Employee Form Submitted Successfully!', { variant: 'success' });
          router.push(paths.submitted);
        }
        enqueueSnackbar('Employee Created Successfully!', { variant: 'success' });
        enqueueSnackbar(
          currentEmp ? 'Employee Updated Successfully!' : 'Employee Created Successfully!',
          { variant: 'success' }
        );
        handleSave(); // Save activeStep before API call
        setOpenDialog(true); // Only open if it's really final step
      }
    } catch (error) {
      console.error(error);
      handleApiError(error);
    }
  });
  const handleViewUploadedDocuments = async () => {
    const docCandId = currentEmp?.employeeId || candidateId || id || routeParams?.id;
    if (docCandId) {
      const encryptedId = await fetchEncryptedToken(docCandId, token);
      router.push(paths.dashboard.humanResources.EmployeeDocumentUploadView(encryptedId));
    }
  };

  const handleUploadDocuments = async () => {
    setOpenDialog(false);
    const encryptedId = await fetchEncryptedToken(savedEmployeeId, token);

    router.push(paths.dashboard.humanResources.EmployeeDocumentUpload(encryptedId));
  };

  const handleUploadDocumentsEdit = async (id) => {
    setOpenDialog(false);
    const encryptedId = await fetchEncryptedToken(id, token);


    router.push(paths.dashboard.humanResources.EmployeeDocumentUpload(encryptedId));
  };

  const handleSkipUpload = () => {
    setOpenDialog(false);
    if (!currentEmp) {
      router.push(paths.dashboard.humanResources.EditEmployee(savedEmployeeId));
    }
  };
  // -----------------------------------------------------------------------------------------------------------------------

  const isStepOptional = (step) => step === 1;

  const isStepSkipped = (step) => skipped?.has(step);

  const DynamicData = methods.getValues();

  const employeeId = currentEmp?.employeeId;

  const handleSave = async () => {
    const fieldKeys = Object.keys(stepsvalidator[activeStep]?.fields || {});

    if (fieldKeys.length > 0) {
      const isValid = await trigger(fieldKeys);
      if (!isValid) {
        enqueueSnackbar('Please complete all required fields before saving.', {
          variant: 'warning',
        });
        return; // prevent save if invalid
      }
    }

    if (currentEmp) {
      localStorage.setItem(`activeStep_${employeeId}`, activeStep.toString());
    } else {
      localStorage.setItem('activeStepKey', activeStep.toString());
    }
  };

  const handleNext = async () => {
    let isValid = true;

    if (stepsvalidator[activeStep]) {
      const fieldKeys = Object.keys(stepsvalidator[activeStep].fields || {});

      if (activeStep === 0) {
        if (fieldKeys.length > 0) {
          // Exclude 'candidate' from blocking validation
          const filteredFields = fieldKeys.filter((key) => key !== 'candidate');
          isValid = await trigger(filteredFields);
        }

        // Check candidate manually and show warning if not filled
        const candidateValue = getValues('candidate');

        if (typeof candidateValue === 'undefined' && !currentEmp) {
          enqueueSnackbar('Candidate selection is recommended before proceeding.', {
            variant: 'warning',
            autoHideDuration: 3000,
          });

          return isValid;
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (fieldKeys.length > 0) {
          isValid = await trigger(fieldKeys);
        }
      }
    }

    if (activeStep === steps.length - 1) {
      enqueueSnackbar('Don’t forget to save your changes before proceeding to the next step!', {
        variant: 'warning',
        autoHideDuration: 3000,
      });
    }

    setActiveStep((prev) => {
      const newStep = prev + 1;
      localStorage.setItem(`activeStep_${employeeId || 'new'}`, newStep.toString());
      return newStep;
    });

    // handleStepChange(activeStep + 1);

    setStepCompletionStatus((prev) => {
      const newStatus = [...prev];
      newStatus[activeStep] = isValid;
      return newStatus;
    });
  };

  const handleBack = async () => {
    const fieldKeys = Object.keys(stepsvalidator[activeStep]?.fields || {});

    setActiveStep((prev) => {
      const newStep = Math.max(prev - 1, 0);
      localStorage.setItem(`activeStep_${employeeId || 'new'}`, newStep.toString());
      return newStep;
    });
    // handleStepChange(Math.max(activeStep - 1, 0));
  };

  const handleSaveNext = async () => {
    const currentStepFields = Object.keys(stepsvalidator[activeStep].fields);
    const isValid = await trigger(currentStepFields);

    if (!isValid) {
      console.warn(' Validation failed for step', activeStep);
      enqueueSnackbar('Please complete all required fields before proceeding.', {
        variant: 'warning',
      });
      return;
    }

    // Give the form state a moment to sync
    await new Promise((res) => setTimeout(res, 0));

    const formData = methods.getValues();

    try {

      await handleFormSubmission(formData, true);

      // Save the active step
      if (employeeId) {
        localStorage.setItem(`activeStep_${employeeId}`, (activeStep + 1).toString());
      } else {
        localStorage.setItem('activeStep_new', (activeStep + 1).toString());
      }

      setActiveStep((prev) => prev + 1);
      // handleStepChange(activeStep + 1);

      setStepCompletionStatus((prev) => {
        const newStatus = [...prev];
        newStatus[activeStep] = true;
        return newStatus;
      });
    } catch (err) {
      console.error('Error during Save & Next:', err);
      const msg = err?.response?.data?.message || err?.response?.data?.error || 'Something went wrong while saving. Please try again.';
      enqueueSnackbar(msg, {
        variant: 'error',
      });
    }
  };

  const [changedSections, setChangedSections] = useState({
    basicDetails: false,
    personalDetails: false,
    contactDetails: false,
    eduCertification: false,
    passVisa: false,
    expRef: false,
    bankDetails: false,
    otherDetails: false,
  });

  // Keys for saving and retrieving form data
  const activeStepKey = `activeStep_${employeeId || 'new'}`; // Key for activeStep, 'new' for new candidates


  const validateAllSteps = async () => {
    const newStepStatus = [...stepCompletionStatus]; // Copy previous status

    const validationResults = await Promise.all(
      stepsvalidator.map(async (step, index) => {
        const fieldKeys = Object.keys(step.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await trigger(fieldKeys);
          newStepStatus[index] = isValid;
          return isValid;
        }
        newStepStatus[index] = true; // If no fields, consider it valid
        return true;
      })
    );

    // Update the step status based on validation results
    setStepCompletionStatus(newStepStatus);

    // Return final status (true if all steps are valid)
    const allValid = validationResults.every((result) => result === true);
    return allValid;
  };

  const handleFormSubmission = async (data) => {
    loadingSend.onTrue();
    try {
      const isValid = await validateAllSteps();
      if (isValid) {
        await onSubmit(data);

        if (isOnEmployeeForm && activeStep === steps.length - 1) {
          setIsSubmitted(true);
          router.push(paths.submitted);
        }

      } else {
        enqueueSnackbar('Please complete all required steps before submitting.', {
          variant: 'warning',
        });
      }
    } catch (error) {
      console.error('Error in form submission:', error);
    } finally {
      loadingSend.onFalse();
    }
  };

  const memoizedMethods = useCallback(methods, [methods]);

  const empCode = watch('empCode');

  const validateCompletedSteps = async (parsedStep, stepperKey) => {
    const newStatus = [...stepCompletionStatus];

    for (let i = 0; i <= parsedStep; i += 1) {
      const validator = stepsvalidator[i];
      if (validator) {
        const fieldKeys = Object.keys(validator.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await methods.trigger(fieldKeys);
          newStatus[i] = isValid;
        } else {
          newStatus[i] = true;
        }
      } else {
        newStatus[i] = true;
      }
    }

    setStepCompletionStatus(newStatus);
  };

  useEffect(() => {
    const empId = currentEmp?.employeeId;

    // Case 0: If disabled, force activeStep = 0
    if (disabled) {
      setActiveStep(0);
      return;
    }

    const restoreAndValidate = async (parsedStep, stepperKey) => {
      const savedFormData = JSON.parse(localStorage.getItem(`stepperFormData_${stepperKey}`));

      if (savedFormData) {
        await Promise.all(
          Object.entries(savedFormData).map(([key, value]) =>
            methods.setValue(key, value, {
              shouldTouch: false,
              shouldDirty: false,
              shouldValidate: false,
            })
          )
        );
      }

      // ✅ Let RHF fully mount
      await new Promise((resolve) => setTimeout(resolve, 100));

      // ✅ Trigger validation on each step and mark status
      const newStatus = [...stepCompletionStatus];
      for (let i = 0; i <= parsedStep; i += 1) {
        const fieldKeys = Object.keys(stepsvalidator[i]?.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await methods.trigger(fieldKeys);
          newStatus[i] = isValid;
        } else {
          newStatus[i] = true;
        }
      }

      setStepCompletionStatus(newStatus);
    };

    // Case 1: New candidate (no ID yet)
    if (!empId) {
      if (!isInitializedNewEmpRef.current) {
        isInitializedNewEmpRef.current = true;
        if (!candidateData && !candidateId) {
          methods.reset(); // clean state on initial mount only when no candidate data
        }
        localStorage.removeItem('stepperFormData_new');
        setActiveStep(0);

        // ✅ Set step completion status to true by default (no ❗ for new)
        const initialStatus = steps.map(() => true);
        setStepCompletionStatus(initialStatus);
      }

      return;
      // eslint-disable-next-line no-else-return
    } else {
      // existing candidate — restore saved step and validate
      const savedStep = localStorage.getItem('activeStep_new');
      const parsedStep = savedStep ? parseInt(savedStep, 10) : 0;
      setActiveStep(Number.isNaN(parsedStep) ? 0 : parsedStep);
      restoreAndValidate(parsedStep, empId);
    }

    // Case 2: Candidate ID just assigned (new → current candidate migration)
    const candidateStepKey = `activeStep_${empId}`;
    const newStep = localStorage.getItem('activeStep_new');
    const existingStep = localStorage.getItem(candidateStepKey);

    if (newStep && !existingStep) {
      const parsedStep = parseInt(newStep, 10);
      const nextStep = Number.isNaN(parsedStep) ? 0 : parsedStep;

      localStorage.setItem(candidateStepKey, nextStep.toString());
      localStorage.setItem('activeStepKey', nextStep.toString());
      localStorage.removeItem('activeStep_new');

      setActiveStep(nextStep); // ✅ Go to next step
      restoreAndValidate(nextStep, empId);
      return;
    }

    // Case 3: Load from existing candidate
    const savedStep =
      localStorage.getItem(candidateStepKey) || localStorage.getItem('activeStepKey');
    const parsedStep = savedStep ? parseInt(savedStep, 10) : 0;
    setActiveStep(Number.isNaN(parsedStep) ? 0 : parsedStep);

    restoreAndValidate(parsedStep, empId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmp, disabled, methods]);

  // Common handler for both switches
  const handleSwitchChange = (event, section) => {

    const isChecked = event.target.checked;

    setSwitchState((prevState) => ({
      ...prevState,
      [section]: isChecked,
    }));

    // Reset form fields if switch is turned off
    if (section === 'experience' && isChecked) {
      // Add default experience item when switch turns ON
      setValue('empExp', [
        {
          expSrno: 0,
          compNm: '',
          designation: null,
          ctc: 0,
          ctccurncy: null,
          country: null,
          expfromDate: null,
          exptoDate: null,
        },
      ]);
    }

    if (section === 'passport' && isChecked) {
      // Add default experience item when switch turns ON
      setValue('empPassport', [
        {
          passSrno: 0,
          passNo: '',
          issuePlace: null,
          issueDt: null,
          expiryDt: null,
          ecnrStamp: false,
        },
      ]);
    }

    if (section === 'visa' && isChecked) {
      // Add default experience item when switch turns ON
      setValue('empVisa', [
        {
          visaSrno: 0,
          visaNo: '',
          visaTyp: null,
          visaNm: null,
          expiryDt: null,
          issueDt: null,
          placeOfissue: null,
          forCntry: null,
        },
      ]);
    }

    if (section === 'passport' && !isChecked) {
      setValue('empPassport', []);
    }

    if (section === 'experience' && !isChecked) {
      setValue('empExp', []);
    }

    if (section === 'visa' && !isChecked) {
      setValue('empVisa', []);
    }
  };


  const parseValidDate = (val) => {
    const date = typeof val === 'string' ? parseISO(val) : new Date(val);
    return isValid(date) ? date : new Date(); // fallback to today
  };

  const handleNoPassport = () => {
    setSwitchState((prev) => ({ ...prev, passport: false }));
    setValue('empPassport', []);
  };
  const handleNoVisa = () => {
    setSwitchState((prev) => ({ ...prev, visa: false }));
    setValue('empVisa', []);
  };
  const handleNoExperience = () => {
    setSwitchState((prev) => ({ ...prev, experience: false }));
    setValue('empExp', []);
  };

  const basicFirstName = watch('fname');
  const basicLastName = watch('lname');
  const basicEmail = watch('email');


  const isBasicDetailsFilled =
    Boolean(basicFirstName) &&
    Boolean(basicLastName) &&
    Boolean(basicEmail);

  return (
    <Grid container spacing={3}>
      <Grid xs={12} md={12}>
        <>
          {!isOnEmployeeForm && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                color="secondary"
                variant="soft"
                startIcon={<Iconify icon="carbon:view" />}
                onClick={() => router.push(paths.dashboard.humanResources.ListOfUnderReviewedEmp)}
              >
                Under Review List
              </Button>
            </Box>
          )}
        </>

        <Stepper
          activeStep={activeStep}
          sx={{ mb: 1, padding: '0px !important', marginTop: '8px' }}
        >
          {steps.map((label, index) => (
            <Step
              key={index}
              sx={{
                '&:hover': { cursor: 'pointer', backgroundColor: '#f2f3f4', borderRadius: '8px' },
              }}
            >
              <StepLabel
                StepIconProps={{
                  completed: stepCompletionStatus[index] === true && index < activeStep,
                  // eslint-disable-next-line no-nested-ternary
                  icon:
                    index === activeStep ? (
                      activeStep + 1
                    ) : // eslint-disable-next-line no-nested-ternary
                      stepCompletionStatus[index] === true ? (
                        index + 1
                      ) : stepCompletionStatus[index] === false && index <= activeStep ? (
                        <span
                          style={{
                            backgroundColor: '#f2f3f4', // Yellow background
                            borderRadius: '50%', // Circle shape
                            width: '24px', // Adjust size
                            height: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                          }}
                        >
                          <img
                            src="/assets/icons/menu-items/material-symbols--exclamation.png"
                            alt="❗"
                            style={{ height: '25px', width: '25px' }}
                          />
                        </span>
                      ) : (
                        // only if validation failed AND step was visited
                        index + 1
                      ), // Default: Show step number
                }}
                sx={{
                  fontWeight: 200,
                  cursor: 'pointer',
                  borderRadius: '8px',
                  position: 'sticky',
                  padding: '0px !important',
                  transition: 'background-color 0.3s ease',
                  '&:hover': {
                    color: 'primary.dark',
                    cursor: 'pointer',
                    backgroundColor: '#f2f3f4',
                  },
                }}
                onClick={async () => {
                  if (index === activeStep) return;

                  const newStatus = [...stepCompletionStatus];

                  const currentFields = Object.keys(stepsvalidator[activeStep]?.fields || {});
                  if (currentFields.length > 0) {
                    const isValid = await trigger(currentFields);
                    newStatus[activeStep] = isValid;
                  }

                  const targetFields = Object.keys(stepsvalidator[index]?.fields || {});
                  if (targetFields.length > 0) {
                    const isTargetValid = await trigger(targetFields);
                    newStatus[index] = isTargetValid;
                  }

                  setStepCompletionStatus(newStatus);

                  setActiveStep(index);
                  localStorage.setItem(
                    employeeId ? `activeStep_${employeeId}` : 'activeStepKey',
                    index.toString()
                  );

                  if (!newStatus[index]) {
                    enqueueSnackbar('Please complete required fields before proceeding.', {
                      variant: 'warning',
                    });
                  }
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <Card
          sx={{
            p: 3,
            width: '100%', // Scale the form to 75% of the container width
            margin: 'auto', // Center the form horizontally
            transform: 'scale(0.98)', // Scale down the entire form
            transformOrigin: 'top center', // Maintain scale position
          }}
        >
          <FormProvider methods={methods} disabled={disabled}>
            <>
              {/* --------------------------------------------------- Basic Details ------------------------------------------------------------- */}
              {activeStep === 0 && (
                <>
                  <Box>
                    <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                      Basic Details:
                    </Typography>
                  </Box>
                  <Box
                    rowGap={3}
                    columnGap={2}
                    display="grid"
                    gridTemplateColumns={{
                      xs: 'repeat(1, 1fr)',
                      sm: 'repeat(2, 1fr)',
                    }}
                  >
                    <Grid xs={12} md={12} sx={{ pr: 0 }}>
                      <Box sx={{ mb: 1 }}>
                        <RHFUploadAvatar
                          name="avatarUrl"
                          maxSize={maxSizeOfDocs}
                          onDrop={handleDrop}
                          disabled={disabled}
                          acceptFile={{
                            'image/jpeg': [],
                            'image/png': [],
                            'image/jpg': [],
                            'image/gif': [],
                            'image/svg+xml': [],
                            'image/heic': [],
                            'image/heif': [],
                            'image/tiff': [],
                            'image/webp': [],
                          }}
                          helperText={
                            !disabled && (
                              <Typography
                                variant="caption"
                                sx={{
                                  mt: 2,
                                  mx: 'auto',
                                  display: 'block',
                                  textAlign: 'center',
                                  color: 'text.secondary',
                                }}
                              >
                                Supported file formats: JPG, JPEG, PNG,
                                <Tooltip
                                  title="Additional formats: GIF, SVG, HEIC, HEIF, TIFF, WebP, JFIF"
                                  arrow
                                  placement="top"
                                >
                                  <Typography
                                    variant="caption"
                                    component="span"
                                    sx={{
                                      cursor: 'pointer',
                                      ml: 0.5,
                                      textDecoration: 'underline',
                                      color: 'primary.main',
                                    }}
                                  >
                                    (more)
                                  </Typography>
                                </Tooltip>
                                <br />
                                Max upload file size: {maxSizeOfDocs} MB
                                <br />
                                <br />
                              </Typography>
                            )
                          }
                        />
                        {!disabled &&
                          !isFileTooLarge &&
                          (curEmpPic || (profilePhotoUrl && !isProfilePhotoRemoved)) && (
                            <>
                              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                <Button
                                  variant="soft"
                                  color="error"
                                  onClick={openConfirmDialog}
                                  disabled={!curEmpPic && !profilePhotoUrl}
                                >
                                  Remove Photo
                                </Button>
                              </Box>

                              <ConfirmDialog
                                open={confirmOpen}
                                onClose={closeConfirmDialog}
                                title="Remove Photo?"
                                content="Are you sure you want to remove the photo?"
                                action={
                                  <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                      handleRemovePhoto();
                                      closeConfirmDialog();
                                    }}
                                  >
                                    Confirm Remove
                                  </Button>
                                }
                              />
                            </>
                          )}
                        {currentEmp ? (
                          <>
                            {empCode && (
                              <Box sx={{ mt: 2 }}>
                                <RHFTextField
                                  name="empCode"
                                  label="Employee Code"
                                  disabled
                                />
                              </Box>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Box>
                    </Grid>
                    <Grid xs={12} md={12}>
                      <Box>
                        {currentEmp ? (
                          <></>
                        ) : (
                          <Stack spacing={1.5} mb={1}>
                            <RHFAutocomplete
                              name="candidate"
                              label={
                                <div>
                                  Candidate-Email
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                </div>
                              }
                              disabled // Always disabled since it's based on candidateId from URL
                              options={selectedCandidate ? [selectedCandidate] : offeredCand}
                              getOptionLabel={(option) => {
                                if (!option) return '';
                                if (typeof option === 'string') return option;
                                const name = `${option.firstName || ''} ${option.lastName || ''}`.trim();
                                const decEmail = option.email
                                  ? option.email.includes('@')
                                    ? option.email
                                    : decryptData(option.email)
                                  : '';
                                return name && decEmail ? `${name} (${decEmail})` : name || decEmail || 'Candidate';
                              }}
                              placeholder="Candidate will be auto-selected"
                              renderOption={(props, option) => {
                                const name = `${option.firstName || ''} ${option.lastName || ''}`.trim();
                                const decEmail = option.email
                                  ? option.email.includes('@')
                                    ? option.email
                                    : decryptData(option.email)
                                  : '';
                                return (
                                  <li {...props} key={option.candidateId || option.email}>
                                    {name} {decEmail ? `(${decEmail})` : ''}
                                  </li>
                                );
                              }}
                            />
                          </Stack>
                        )}
                        {/* <Stack spacing={1.5} mb={1}>
                          <Controller
                            name="empTyp"
                            control={control}
                            render={({ field }) => (
                              <RHFAutocomplete
                                {...field} // Pass RHF field props to the autocomplete
                                placeholder="Employment Type"
                                label={
                                  <div>
                                    Employment Type
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                  </div>
                                }
                                options={empTypArr}
                                getOptionLabel={(option) => option.masterName}
                                showPlusIcon
                                onChange={(event, newValue) => {
                                  setSelectedEmpType(newValue);
                                  setValue('empTyp', newValue, { shouldValidate: true });
                                }}
                                renderOption={(props, option) => (
                                  <li {...props} key={option.masterId}>
                                    {option.masterName}
                                  </li>
                                )}
                              />
                            )}
                          />
                        </Stack> */}
                        {!isOnEmployeeForm && (
                          <>
                            <Stack spacing={1.5} mb={1}>
                              <RHFAutocomplete
                                name="empTyp"
                                placeholder="Employment Type"
                                label={
                                  <div>
                                    Employment Type
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                  </div>
                                }
                                options={empTypArr || []}
                                getOptionLabel={(option) => option?.employmentTypeName || ''}
                                showPlusIcon
                                renderOption={(props, option) => (
                                  <li {...props} key={option?.employmentTypeId}>
                                    {option?.employmentTypeName || ''}
                                  </li>
                                )}
                              />
                            </Stack>
                          </>
                        )}
                        {/* ---------------------------------------------------------------------------- */}
                        {!isOnEmployeeForm &&
                          watchedEmpTyp &&
                          ['Freelance', 'Full-time Employment', 'Full-time Employment'].includes(
                            watchedEmpTyp.masterName
                          ) && (
                            <Stack spacing={1.5} mt={1} mb={1}>
                              <Controller
                                name="empGrade"
                                control={control}
                                render={({ field }) => (
                                  <RHFAutocomplete
                                    {...field} // Pass RHF field props to the autocomplete
                                    placeholder="Employee Grade"
                                    label={
                                      <div>
                                        Employee Grade
                                        <span style={{ color: 'red', fontWeight: 'bolder' }}>
                                          {' '}
                                          *
                                        </span>
                                      </div>
                                    }
                                    options={empGradeArr}
                                    getOptionLabel={(option) => option.masterName}
                                    showPlusIcon
                                    onChange={(event, newValue) => {
                                      setValue('empGrade', newValue, { shouldValidate: true });
                                    }}
                                    renderOption={(props, option) => (
                                      <li {...props} key={option.masterId}>
                                        {option.masterName}
                                      </li>
                                    )}
                                  />
                                )}
                              />
                            </Stack>
                          )}
                        {/* --------------------------------------------------------------------------------- */}
                        {empCode && (
                          <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
                            <RHFTextField
                              name="empCode"
                              label="Employee Code"
                              disabled
                            />
                          </Box>
                        )}
                        {!isOnEmployeeForm && (
                          <>
                            <Controller
                              name="dateOfJoin"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <DatePicker
                                  label={
                                    <div>
                                      Date of Joining
                                      <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                    </div>
                                  }
                                  value={parseValidDate(field.value)}
                                  onChange={(newValue) => field.onChange(newValue)}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      error: !!error,
                                      helperText: error?.message,
                                    },
                                  }}
                                  sx={{ mb: 2 }}
                                  minDate={lastUpdatedDateCand}
                                />
                              )}
                            />

                            <Stack spacing={1.5} mb={2}>
                              <RHFAutocomplete
                                name="designation"
                                placeholder="Post/Designation"
                                label={
                                  <div>
                                    Designation
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                  </div>
                                }
                                options={desgntnArr}
                                showPlusIcon
                                getOptionLabel={(option) => option.masterName}
                                renderOption={(props, option) => (
                                  <li {...props} key={option.masterId}>
                                    {option.masterName}
                                  </li>
                                )}
                              />
                            </Stack>
                          </>
                        )}
                      </Box>
                    </Grid>
                  </Box>
                </>
              )}
            </>
            {/* -------------------------------------- personal Details --------------------------------------------------------------------- */}
            <Grid xs={12} md={12}>
              <>
                {activeStep === 1 && (
                  <>
                    <Box>
                      <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                        Personal Details:
                      </Typography>
                    </Box>
                    <Box
                      rowGap={3}
                      columnGap={2}
                      display="grid"
                      gridTemplateColumns={{
                        xs: 'repeat(1, 1fr)',
                        sm: 'repeat(2, 1fr)',
                      }}
                      sx={{ mb: 3 }}
                    >
                      <Tooltip
                        title={
                          !isBasicDetailsFilled
                            ? 'Please fill Basic Details first.'
                            : ''
                        }
                        arrow
                        placement="top"
                      >  <span>
                          <RHFTextField
                            name="fname"
                            label={
                              <div>
                                First Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            disabled={!currentEmp && Boolean(watch('fname'))}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Box component="span" sx={{ color: 'text.disabled' }}>
                                    <RHFAutocomplete
                                      name="nameTitle"
                                      disableClearable
                                      sx={{
                                        '& fieldset': { border: 'none' },
                                      }}
                                      disabled={!currentEmp && Boolean(watch('nameTitle'))}
                                      options={nmTitleArr}
                                      getOptionLabel={(option) => option.masterName}
                                      componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                      renderOption={(props, option) => (
                                        <li {...props} key={option.masterId}>
                                          {option.masterName}
                                        </li>
                                      )}
                                    />
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </span>
                      </Tooltip>
                      <RHFTextField name="mname" label="Middle Name" />
                      <Tooltip
                        title={
                          !isBasicDetailsFilled
                            ? 'Please fill Basic Details first.'
                            : ''
                        }
                        arrow
                      ><span>
                          <RHFTextField
                            name="lname"
                            label={
                              <div>
                                Last Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            disabled={!currentEmp && Boolean(watch('lname'))}
                          />
                        </span>
                      </Tooltip>
                      <Controller
                        name="dateOfBirth"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <DatePicker
                            label="Date of Birth"
                            value={parseValidDate(field.value) ?? new Date()}
                            onChange={(newValue) => field.onChange(newValue)}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!error,
                                helperText: error?.message,
                              },
                            }}
                            maxDate={new Date()}
                          />
                        )}
                      />
                      <RHFTextField name="placeOfBirth" label="Place of Birth" />
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="gender"
                          placeholder="Gender"
                          label={
                            <div>
                              Gender<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                          disabled={!currentEmp && Boolean(watch('gender'))}
                          showPlusIcon
                          options={genderArr}
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="religion"
                          placeholder="Religion"
                          label="Religion"
                          options={relgnArr}
                          showPlusIcon
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="maritalStatus"
                          placeholder="Marital Status"
                          label="Marital Status"
                          options={maritalStArr}
                          showPlusIcon
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <RHFTextField name="nationality" label="Nationality" />
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="bloodGrp"
                          placeholder="Blood Group"
                          label="Blood Group"
                          options={bloodGrpArr}
                          showPlusIcon
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <RHFTextField
                        name="height"
                        type="number"
                        label="Height"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Box component="span" sx={{ color: 'text.disabled' }}>
                                <RHFAutocomplete
                                  name="unitOfHeight"
                                  disableClearable
                                  placeholder="cm."
                                  sx={{
                                    '& fieldset': { border: 'none' },
                                  }}
                                  options={unitOfMsrArr}
                                  getOptionLabel={(option) => option.masterName}
                                  componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.masterId}>
                                      {option.masterName}
                                    </li>
                                  )}
                                />
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <RHFTextField
                        name="weight"
                        type="number"
                        label="Weight"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Box component="span" sx={{ color: 'text.disabled' }}>
                                <RHFAutocomplete
                                  name="unitOfWeight"
                                  disableClearable
                                  placeholder="kg."
                                  sx={{
                                    '& fieldset': { border: 'none' },
                                  }}
                                  options={unitOfMsrArr}
                                  getOptionLabel={(option) => option.masterName}
                                  componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.masterId}>
                                      {option.masterName}
                                    </li>
                                  )}
                                />
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Tooltip
                        title={
                          !isBasicDetailsFilled
                            ? 'Please fill Basic Details first.'
                            : ''
                        }
                        arrow
                      ><span>
                          <RHFTextField
                            name="email"
                            label={
                              <div>
                                Personal Email
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            disabled={!currentEmp && Boolean(watch('email'))}
                          />
                        </span>
                      </Tooltip>
                      {currentEmp ? (
                        <>
                          <RHFTextField name="ofclEmail" label={<div>Official Email</div>} />
                        </>
                      ) : (
                        <></>
                      )}
                      <Tooltip
                        title={
                          !isBasicDetailsFilled
                            ? 'Please fill Basic Details first.'
                            : ''
                        }
                        arrow
                      ><span>
                          <RHFTextField
                            name="mobno"
                            label={
                              <div>
                                Mobile Number
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            disabled={!currentEmp && Boolean(watch('mobno'))}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Box component="span" sx={{ color: 'text.disabled' }}>
                                    <RHFAutocomplete
                                      name="phncode"
                                      disableClearable
                                      filterOptions={filterPhoneCode}
                                      sx={{
                                        '& fieldset': { border: 'none' },
                                        '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
                                          padding: '9.5px 20px 10.5px 4px !important', // Add specific PADDING for the Autocomplete input
                                        },
                                        minWidth: 40,
                                      }}
                                      disabled={!currentEmp && Boolean(watch('phncode'))}
                                      options={countryArr}
                                      onChange={(event, value) => {
                                        setValue('phncode', value, { shouldValidate: true });
                                        trigger('mobno');
                                      }}
                                      getOptionLabel={(option) => option?.phoneCode || ''}
                                      componentsProps={{
                                        popper: { style: { width: 'fit-content' } },
                                      }}
                                      renderOption={(props, option) => (
                                        <li {...props} key={option.shortName}>
                                          {option.countryName}({option.phoneCode})
                                        </li>
                                      )}
                                    />
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </span>
                      </Tooltip>
                      <Controller
                        name="panno"
                        control={methods.control}
                        rules={{
                          required: 'PAN is required',
                        }}
                        render={({ field, fieldState }) => (
                          <MaskedInput
                            field={field}
                            error={fieldState.error}
                            maskType="PAN"
                            label={
                              <div>
                                PAN Number{' '}
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            sx={{ width: '40%' }}
                          />
                        )}
                      />

                      <Controller
                        name="aadharno"
                        control={methods.control}
                        rules={{
                          required: 'Aadhaar is required',
                        }}
                        render={({ field, fieldState }) => (
                          <MaskedInput
                            field={field}
                            error={fieldState.error}
                            maskType="AADHAAR"
                            label={
                              <div>
                                Aadhaar Number{' '}
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            sx={{ width: '35%' }}
                          />
                        )}
                      />
                      <RHFTextField name="pfno" label="PF Number(UAN)" />
                      <RHFTextField name="pranno" label="NPS Number(PRAN)" />
                      <Stack spacing={1}>
                        <RHFTextField name="linkedinLink" label="LinkedIn Profile Url" />
                      </Stack>
                      <Stack spacing={1}>
                        <Box
                          rowGap={3}
                          columnGap={2}
                          display="grid"
                          gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(2, 1fr)',
                          }}
                        >
                          <Typography variant="subtitle2" mt={1}>
                            Is International Worker:
                          </Typography>
                          <RHFRadioGroup
                            row
                            spacing={4}
                            name="isInternationalWrkr"
                            options={yesNoArr}
                          />
                        </Box>
                      </Stack>
                      <Stack spacing={1}>
                        <Box
                          rowGap={2}
                          columnGap={1}
                          display="grid"
                          gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: '1fr 2fr',
                          }}
                        >
                          <Typography variant="subtitle2" mt={1}>
                            Is Director:
                          </Typography>
                          <RHFRadioGroup row spacing={4} name="isdirector" options={yesNoArr} />
                        </Box>
                      </Stack>
                    </Box>
                  </>
                )}
              </>
              {/* ----------------------------------------------- Professional Details ------------------------------------------------------  */}
              <>
                {activeStep === 2 && (
                  <>
                    <Box>
                      <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                        Address Details:
                      </Typography>
                    </Box>
                    <>
                      <Typography variant="subtitle2" sx={{ mb: '10px' }}>
                        Current Address :
                      </Typography>
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                        sx={{ mb: 3 }}
                      >
                        <RHFTextField
                          name="curAddLn1"
                          label={
                            <div>
                              Address Line 1
                              <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                        />
                        <RHFTextField name="curAddLn2" label="Address Line 2" />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="curAddCntr"
                            placeholder="Country"
                            disableClearable
                            label={
                              <div>
                                Country
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={countryArr}
                            getOptionLabel={(option) => option.countryName}
                            onChange={(event, value) => {
                              setValue('curAddCntr', value, { shouldValidate: true });
                              if (curStateArr.length > 0) {
                                setValue('curAddState', null, { shouldValidate: true });
                              }
                              if (curCityArr.length > 0) {
                                setValue('curAddCity', null, { shouldValidate: true });
                              }
                              handleCountryChange(value.countriesId);
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.shortName}>
                                {option.countryName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="curAddState"
                            placeholder="State"
                            disableClearable
                            label={
                              <div>
                                State
                                {curStateArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={[...curStateArr].sort((a, b) => {
                              const stateNameA = a.stateName?.toLowerCase() || ''; // Ensure stateName is a string
                              const stateNameB = b.stateName?.toLowerCase() || ''; // Ensure stateName is a string

                              return stateNameA.localeCompare(stateNameB); // Sort states alphabetically
                            })}
                            getOptionLabel={(option) => option.stateName}
                            onChange={(event, value) => {
                              setValue('curAddState', value, { shouldValidate: true });
                              if (curCityArr.length > 0) {
                                setValue('curAddCity', null, { shouldValidate: true });
                              }
                              handleStateChange(value.statesId);
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.statesId}>
                                {option.stateName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="curAddCity"
                            placeholder="City"
                            disableClearable
                            label={
                              <div>
                                City
                                {curCityArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={curCityArr}
                            getOptionLabel={(option) => option.cityName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.cityId}>
                                {option.cityName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFTextField name="curAddLandMrk" label="Landmark" />
                        <RHFTextField
                          name="curAddZip"
                          label="Zip Code"
                          inputProps={{
                            inputMode: 'numeric', // Mobile keyboard shows numbers
                            pattern: '[0-9]*', // HTML pattern to accept only digits
                            maxLength: 6, // 👈 limit to 6 digits max
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Removes non-numeric chars
                          }}
                        />
                        <RHFTextField name="curAddLandLn" label="Landline Number" />
                      </Box>
                      <Typography variant="subtitle2" sx={{ mb: '10px' }}>
                        Permanent Address :
                      </Typography>
                      <FormControlLabel
                        control={
                          <Checkbox
                            id="isSameAsCurrent"
                            checked={isCurrentAndPermanentAddressSame()}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Same as current address"
                        sx={{ mb: '10px' }}
                      />
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                      >
                        <RHFTextField
                          name="permAddLn1"
                          label={
                            <div>
                              Address Line 1
                              <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                        />
                        <RHFTextField name="permAddLn2" label="Address Line 2" />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="permAddCntr"
                            placeholder="Country"
                            disableClearable
                            label={
                              <div>
                                Country
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={countryArr}
                            getOptionLabel={(option) => option.countryName}
                            onChange={(event, value) => {
                              setValue('permAddCntr', value, { shouldValidate: true });
                              if (curStateArr.length > 0) {
                                setValue('permAddState', null, { shouldValidate: true });
                              }
                              if (curCityArr.length > 0) {
                                setValue('permAddCity', null, { shouldValidate: true });
                              }
                              handlePerCountryChange(value.countriesId);
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.shortName}>
                                {option.countryName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="permAddState"
                            placeholder="State"
                            disableClearable
                            label={
                              <div>
                                State
                                {perStateArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={perStateArr}
                            getOptionLabel={(option) => option.stateName}
                            onChange={(event, value) => {
                              setValue('permAddState', value, { shouldValidate: true });
                              if (curCityArr.length > 0) {
                                setValue('permAddCity', null, { shouldValidate: true });
                              }
                              handlePerStateChange(value.statesId);
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.statesId}>
                                {option.stateName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="permAddCity"
                            placeholder="City"
                            disableClearable
                            label={
                              <div>
                                City
                                {perCityArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={perCityArr}
                            getOptionLabel={(option) => option.cityName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.cityId}>
                                {option.cityName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFTextField name="permAddLandMrk" label="Landmark" />
                        <RHFTextField
                          name="permAddZip"
                          label="Zip Code"
                          inputProps={{
                            inputMode: 'numeric', // Mobile keyboard shows numbers
                            pattern: '[0-9]*', // HTML pattern to accept only digits
                            maxLength: 6, //  limit to 6 digits max
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Removes non-numeric chars
                          }}
                        />

                        <RHFTextField name="permAddLandLn" label="Landline Number" />
                      </Box>
                    </>
                  </>
                )}
              </>
              {/* ---------------------------------------- Passport Details -------------------------------------------------------------- */}
              <>
                {activeStep === 4 && (
                  <>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={switchState.passport}
                          onChange={(event) => handleSwitchChange(event, 'passport')}
                          name="passportSwitch"
                          color="primary"
                        />
                      }
                      label="Do you have a passport?"
                    />

                    {switchState.passport && (
                      <PassportNewEditForm
                        citiesData={rawCityArr}
                        switchState={switchState}
                        onEmptyPassport={handleNoPassport}
                      />
                    )}
                  </>
                )}
              </>
              {/* ---------------------------------------- Visa Details ------------------------------------------------------------------- */}
              <>
                {activeStep === 4 && (
                  <>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={switchState.visa}
                          onChange={(event) => handleSwitchChange(event, 'visa')}
                          name="visaSwitch"
                          color="primary"
                        />
                      }
                      label="Do you have a visa?"
                    />

                    {switchState.visa && (
                      <EmpVisaNewEditForm
                        visaNmArr={visaNmArr}
                        visaTypArr={visaTypArr}
                        citiesData={rawCityArr}
                        countryArr={countryArr}
                        switchState={switchState}
                        onEmptyVisa={handleNoVisa}
                      />
                    )}
                  </>
                )}
              </>
              {/* ---------------------------------- Family Details ----------------------------------------------------------------------- */}
              <>
                {activeStep === 1 && (
                  <>
                    <FamilyRelationNewEditForm relshnData={relshnshipArr} yesNoArr={yesNoArr} />
                  </>
                )}
              </>
              {/* ---------------------------------- Emergency Contact Details ------------------------------------------------------------ */}
              <>
                {activeStep === 2 && (
                  <>
                    <EmergencyContactNewEditForm
                      countryArr={countryArr}
                      relshnData={relshnshipArr}
                    />
                  </>
                )}
              </>
              {/* ---------------------------------- Education Details --------------------------------------------------------------------- */}
              <>
                {activeStep === 3 && (
                  <>
                    <EmpEduNewEditForm
                      universityData={universityArr}
                      qualData={qualArr}
                      qualTypeData={qualTypeArr}
                      streamData={streamArr}
                      currentEmpEdu={currentEmpEdu}
                    />
                  </>
                )}
              </>
              {/* ------------------------------------------------- Certification Details ---------------------------------------------- */}
              <>
                {activeStep === 3 && (
                  <>
                    <EmpCertNewEditForm certNmArr={certNmArr} certInstNmArr={certInstNmArr} />
                  </>
                )}
              </>
              {/* ------------------------------------------------- Experience Details ---------------------------------------------------- */}
              <>
                {activeStep === 5 && (
                  <>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={switchState.experience}
                          onChange={(event) => handleSwitchChange(event, 'experience')}
                          name="expSwitch"
                          color="primary"
                        />
                      }
                      label="Have an Experience ?"
                    />
                    {switchState.experience && (
                      <EmpExpNewEditForm
                        desgData={desgntnArr}
                        cntryData={countryArr}
                        filterCurrency={filterCurrency}
                        trigger={trigger}
                        switchState={switchState}
                        onEmptyExperience={handleNoExperience}
                      />
                    )}
                  </>
                )}
              </>
              {/* ------------------------------------------------- Reference Details ----------------------------------------------------- */}
              <>
                {activeStep === 5 && (
                  <>
                    <EmpRefNewEditForm
                      desgRefData={desgntnArr}
                      countryArr={countryArr}
                      filterPhoneCode={filterPhoneCode}
                    />
                  </>
                )}
              </>
              {/* ---------------------------------------------- Language Details  ---------------------------------------------------------- */}
              <>
                {activeStep === 3 && (
                  <>
                    <EmpLangNewEditForm langarr={langArr} />
                  </>
                )}
              </>
              {/* ------------------------------------------------- bank Details --------------------------------------------------- */}
              <>
                {activeStep === 6 && (
                  <>
                    <EmpBankNewEditForm bankNmData={bankNmArr} bankTypeData={bankTypArr} />
                  </>
                )}
              </>
              {/* ------------------------------------------------- Important Questions --------------------------------------------  */}
              <>
                {activeStep === steps.length - 1 ? (
                  isSubmitted ? (
                    <></>
                  ) : (
                    <>
                      {/* Content for the Final Step */}
                      <Box>
                        <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                          Other Details:
                        </Typography>
                      </Box>
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                      >
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="srcofhire"
                            placeholder="Select Source Of Hire"
                            label={
                              <div>
                                Source Of Hire
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={srcOfHrArr}
                            disabled={!currentEmp && Boolean(watch('srcofhire'))}
                            getOptionLabel={(option) => option.sourceName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.sourceName}>
                                {option.sourceName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFTextField name="srcofhireNm" label="Source Name" />
                      </Box>
                      <EmpRelwrknwithusNewEditForm
                        relshnData={relshnshipArr}
                        countryArr={countryArr}
                        desgRefData={desgntnArr}
                      />
                      <EmpImpqueNewEditForm impQueArr={impQueArr} />

                      <Stack
                        justifyContent="space-between"
                        direction="row"
                        spacing={2}
                        sx={{ mt: 3 }}
                      >
                        {/* Back Button */}
                        {!disabled && (
                          <Button
                            variant="soft"
                            onClick={handleBack}
                            sx={{
                              color: '#00838f',
                              bgcolor: '#CAFDF5',
                              '&:hover': {
                                bgcolor: '#CAFDF5',
                              },
                            }}
                          >
                            Previous
                          </Button>
                        )}

                        {!disabled && activeStep === steps.length - 1 && (
                          <>
                            {currentEmp && !isOnEmployeeForm && (
                              <LoadingButton
                                type="button"
                                variant="soft"
                                color="success"
                                sx={{ mr: 1 }}
                                disabled={isGenerating}
                                onClick={async () => {
                                  setSavingAction('saveOnly');
                                  try {
                                    await handleFormSubmission(methods.getValues(), false); // Only save
                                  } finally {
                                    setSavingAction(null);
                                  }
                                }}
                              >
                                {savingAction === 'saveOnly' ? (
                                  <>
                                    <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                                    Saving...
                                  </>
                                ) : (
                                  'Save Changes'
                                )}
                              </LoadingButton>
                            )}

                            {isOnEmployeeForm && (
                              <LoadingButton
                                type="button"
                                variant="soft"
                                color="success"
                                loading={loadingSend.value}
                                onClick={handleFormSubmission}
                              >
                                Submit Form
                              </LoadingButton>
                            )}
                          </>
                        )}
                      </Stack>
                    </>
                  )
                ) : (
                  // Steps Before Final Step
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mt: 3,
                    }}
                  >
                    {/* Back Button */}
                    {!disabled && activeStep > 0 && (
                      <Button
                        variant="soft"
                        onClick={handleBack}
                        sx={{
                          mr: 2,
                          color: '#00838f',
                          bgcolor: '#CAFDF5', // Optional, for consistent theming
                          '&:hover': {
                            bgcolor: '#CAFDF5',
                          },
                        }}
                      >
                        Previous
                      </Button>
                    )}

                    {/* Spacer to push other buttons to the right */}
                    <Box sx={{ flexGrow: 1 }} />

                    {/* Save Changes Button */}
                    {!disabled && (
                      <>
                        {currentEmp && (
                          <LoadingButton
                            type="button"
                            variant="soft"
                            color="success"
                            sx={{ mr: 1 }}
                            disabled={isGenerating}
                            onClick={async () => {
                              setSavingAction('saveOnly');
                              try {
                                await handleFormSubmission(methods.getValues(), false); // Only save
                              } finally {
                                setSavingAction(null);
                              }
                            }}
                          >
                            {savingAction === 'saveOnly' ? (
                              <>
                                <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                                Saving...
                              </>
                            ) : (
                              'Save Changes'
                            )}
                          </LoadingButton>
                        )}

                        <LoadingButton
                          type="button"
                          variant="soft"
                          sx={{
                            mr: 1,
                            color: '#026544',
                            bgcolor: '#77ed8b7a',
                            '&:hover': {
                              bgcolor: 'success.light',
                            },
                          }}
                          disabled={isGenerating}
                          onClick={async () => {
                            setIsSavingNext(true);
                            setIsGenerating(true);
                            try {
                              await handleSaveNext();
                            } finally {
                              setIsSavingNext(false);
                              setIsGenerating(false);
                            }
                          }}
                        >
                          {isGenerating && isSavingNext ? (
                            <>
                              <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                              Saving...
                            </>
                          ) : (
                            'Save & Next'
                          )}
                        </LoadingButton>
                      </>
                    )}
                  </Box>
                )}
              </>
            </Grid>
          </FormProvider>

          <>
            {/* Only render the navigation buttons if "disabled" is true */}
            {disabled && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end', // Align to the right
                  gap: 2,
                  mt: 4,
                }}
              >
                {/* Back Button */}
                {activeStep > 0 && (
                  <Button
                    variant="soft"
                    onClick={handleBack}
                    sx={{
                      color: '#00838f',
                      bgcolor: '#CAFDF5',
                      '&:hover': {
                        bgcolor: '#CAFDF5',
                      },
                    }}
                  >
                    Previous
                  </Button>
                )}

                {/* Next Button */}
                {activeStep !== steps.length - 1 && currentEmp && (
                  <Button
                    variant="soft"
                    onClick={handleNext}
                    sx={{
                      color: '#026544',
                      bgcolor: '#77ed8b7a',
                      '&:hover': {
                        bgcolor: 'success.light',
                      },
                    }}
                  >
                    Next
                  </Button>
                )}
              </Box>
            )}
          </>
          {currentEmpView && activeStep === 0 && !disabled && !currentEmp ? (
            <Button
              variant="soft"
              color="success"
              style={{ marginTop: '-85px' }}
              onClick={handleUploadDocuments}
            >
              Upload Documents
            </Button>
          ) : (
            activeStep === 0 && (
              <Button
                variant="soft"
                color="success"
                style={{ marginTop: '-45px' }}
                onClick={handleViewUploadedDocuments}
              >
                View Uploaded Documents
              </Button>
            )
          )}
          <Dialog fullWidth maxWidth="xs" open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle sx={{ pb: 2 }}>Upload Documents</DialogTitle>
            <DialogContent sx={{ typography: 'body2' }}>
              {currentEmp
                ? 'Would you like to upload new or edit existing documents?'
                : 'Would you like to upload documents for this employee now?'}
            </DialogContent>
            <DialogActions>
              <Button variant="soft" color="inherit" onClick={handleSkipUpload}>
                Skip
              </Button>
              <Button variant="soft" color="success" onClick={handleUploadDocuments}>
                Upload Documents
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      </Grid>
    </Grid>
  );
}
EmployeeNewEditForm.propTypes = {
  currentEmp: PropTypes.object,
  currentEmpFam: PropTypes.array,
  currentEmpPass: PropTypes.array,
  currentEmpBank: PropTypes.array,
  currentEmpEdu: PropTypes.array,
  currentEmpVisa: PropTypes.array,
  currentEmpCert: PropTypes.array,
  currentEmpWrk: PropTypes.array,
  currentEmpLang: PropTypes.array,
  currentEmpEmrg: PropTypes.array,
  currentEmpRef: PropTypes.array,
  currentEmpExp: PropTypes.array,
  currentEmpImpQ: PropTypes.array,
  currentEmpView: PropTypes.bool,
  disabled: PropTypes.bool,
  candidateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  candidateData: PropTypes.object,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
